{
  "bug": {
    "report": "Reportar un problema",
    "title": "Reportar un problema",
    "intro": "Cuéntanos qué salió mal. Capturaremos una captura de pantalla y tu actividad reciente para ayudarnos a reproducirlo.",
    "describeLabel": "¿Qué pasó?",
    "placeholder": "Paso a paso: 1) qué hiciste, 2) qué esperabas, 3) qué ocurrió en realidad.",
    "submit": "Enviar reporte",
    "sent": "¡Gracias! Tu reporte fue enviado."
  },
  "stepper": {
    "label": "Paso {{current}} de {{total}}",
    "completed": "completado",
    "current": "actual",
    "upcoming": "sin empezar",
    "stepState": "Paso {{current}} de {{total}}, {{state}}"
  },
  "breadcrumbs": {
    "label": "Ruta de navegación"
  },
  "common": {
    "back": "Atrás",
    "loading": "Cargando…",
    "loadingFormats": "Cargando formatos…",
    "cancel": "Cancelar",
    "create": "Crear",
    "clone": "Clonar",
    "delete": "Eliminar",
    "edit": "Editar",
    "view": "Ver",
    "download": "Descargar",
    "search": "Buscar",
    "clearFilters": "Limpiar filtros",
    "prev": "← Anterior",
    "next": "Siguiente →",
    "any": "Cualquiera",
    "apiHint": "El catálogo proviene del servidor — asegúrese de que la API esté en ejecución.",
    "startOver": "Empezar de nuevo",
    "page": "Página {{page}} de {{total}}",
    "save": "Guardar",
    "rename": "Renombrar"
  },
  "language": {
    "label": "Idioma",
    "en": "EN",
    "es": "ES",
    "english": "English",
    "spanish": "Español",
    "changed": "Idioma cambiado.",
    "saveFailed": "No se pudo guardar su preferencia de idioma."
  },
  "theme": {
    "label": "Tema de color",
    "system": "Tema del sistema",
    "light": "Tema claro",
    "dark": "Tema oscuro"
  },
  "comfort": {
    "label": "Tamaño del texto",
    "toggle": "Texto más grande",
    "on": "Más grande",
    "off": "Normal"
  },
  "create": {
    "title": "Crear un nuevo formato EDD",
    "subtitle": "¿Cómo quieres crearlo?",
    "aiTitle": "Créalo con IA",
    "aiBody": "Dile a nuestro asistente, con tus propias palabras, qué archivo necesitas. Te hace unas preguntas sencillas y luego completa todo para que lo revises.",
    "manualTitle": "Configurarlo yo mismo",
    "manualBody": "Empieza desde un formato en blanco y completa la configuración, las columnas y las reglas tú mismo en el editor.",
    "recommended": "Recomendado",
    "chatSubtitle": "Dime qué necesitas. Puedes escribir o tocar el micrófono y hablar.",
    "switchManual": "Mejor lo hago yo",
    "placeholder": "Por ejemplo: un archivo CSV para NYSDEC con una fila de encabezado…",
    "send": "Enviar",
    "openEditor": "Abrir en el editor para revisar",
    "chatPanelLabel": "Chat de IA",
    "draftPaneTitle": "Tu EDD hasta ahora",
    "draftEmpty": "Cuéntame a la derecha qué archivo necesitas — tu EDD toma forma aquí mientras conversamos.",
    "draftUnnamed": "EDD sin título",
    "draftColumns": "{{count}} columnas",
    "draftSampleCols": "Columnas",
    "draftQcCols": "Columnas de QC",
    "draftTransforms": "Cálculos y reglas ({{count}})",
    "draftCrossTables": "Traducciones de valores ({{count}})",
    "draftReadyHint": "¿Se ve bien? Ábrelo en el editor para previsualizar con tus datos y terminar.",
    "setupTitle": "Antes de empezar (opcional)",
    "setupSubtitle": "Dame un ejemplo o algunos formatos para aprender — o sáltate esto y dime qué necesitas.",
    "filesTitle": "Sube tus archivos",
    "filesHint": "¿Tienes un ejemplo del archivo que envías, una especificación escrita o algún documento de referencia? Agrega uno o más y los usaré. ¿No tienes ninguno? No pasa nada — sáltate esto y dime qué necesitas.",
    "filesDrop": "Suelta un archivo aquí, o haz clic para elegir (CSV, texto, especificación, documento…)",
    "attachmentsTitle": "Tus archivos",
    "attachmentsEmpty": "Aún no hay archivos. Suelta uno abajo y lo usaré.",
    "addFile": "Agregar un archivo",
    "removeFile": "Quitar",
    "existingTitle": "Quizás ya tienes esto",
    "existingBody": "Encontré un formato que parece coincidir bastante — {{name}} ({{pct}}% de coincidencia). Podrías usarlo tal cual en vez de crear uno nuevo.",
    "exampleTitle": "¿Tienes un ejemplo del archivo que envías?",
    "exampleHint": "Sube uno y usaré sus columnas exactamente. La mayoría no tiene uno — está bien, sáltalo.",
    "exampleDrop": "Suelta un archivo de ejemplo aquí (CSV)",
    "refTitle": "Empezar desde formatos existentes",
    "refHint": "Elige uno o más de tus formatos como punto de partida. Déjalo vacío para empezar desde cero.",
    "startBuilding": "Empezar a crear",
    "checkingFile": "Revisando tu archivo…",
    "instructionsTitle": "¿Algo que deba saber? (opcional)",
    "instructionsHint": "Agrega contexto con tus propias palabras — para quién es, reglas especiales, columnas que necesitas. Puedes escribir o tocar el micrófono y hablar.",
    "instructionsPlaceholder": "Por ejemplo: es para MDEQ, las fechas deben ser MM/DD/AAAA y necesito una columna de marcas aparte…"
  },
  "filePool": {
    "title": "Lo que recibí",
    "intro": "Esto es lo que entendí de cada archivo. Si me equivoqué en alguno, quítalo o dime para qué es.",
    "listLabel": "Archivos subidos y lo que creo que son",
    "unnamed": "Archivo sin nombre",
    "remove": "Quitar",
    "unknownHint": "⚠ No estoy seguro de qué es esto — quítalo, o dime para qué es.",
    "roles": {
      "sample_results": "Resultados de muestras",
      "qc_results": "Resultados de control de calidad",
      "client_spec": "Especificación del cliente / regulador",
      "cross_table_workbook": "Libro de tablas cruzadas",
      "known_good_output": "Un EDD ya hecho para reproducir",
      "reference_template": "Una plantilla de referencia",
      "unknown": "Archivo no reconocido"
    }
  },
  "nav": {
    "brand": "Prisma EDD Builder",
    "home": "Inicio",
    "account": "Cuenta",
    "menu": "Menú",
    "createEddFile": "Crear archivo EDD",
    "createEddTemplate": "Crear una nueva plantilla EDD",
    "createDeliverable": "Crear un entregable",
    "createEdd": "Crear un nuevo EDD",
    "history": "Historial",
    "formats": "Sus formatos EDD",
    "standards": "Normas",
    "team": "Equipo",
    "connector": "Conector",
    "advanced": "Avanzado",
    "formatLibrary": "Biblioteca de formatos",
    "combineFormats": "Combinar formatos",
    "buildWithAi": "Crear con IA",
    "multipleWorkOrders": "Varias órdenes de trabajo",
    "gettingStarted": "Primeros pasos",
    "savedFormats": "Sus formatos guardados",
    "templates": "Biblioteca de formatos",
    "configs": "Formatos EDD",
    "aiDraft": "Crear un formato con IA",
    "merge": "Combinar formatos",
    "generate": "Crear un entregable",
    "batch": "Varias órdenes de trabajo",
    "jobs": "Historial",
    "specs": "Normas",
    "workers": "Conector de Windows",
    "admin": "Equipo",
    "profile": "Perfil",
    "setup": "Configurar / importar",
    "logout": "Cerrar sesión",
    "groupPrimary": "Principal",
    "groupAdmin": "Administración",
    "codeBooks": "Tablas cruzadas"
  },
  "glossary": {
    "title": "Guía en lenguaje sencillo",
    "edd": {
      "term": "EDD",
      "definition": "Un EDD es un archivo que envía a un regulador o cliente con los resultados de su laboratorio. Piénselo como una boleta de calificaciones del agua o del suelo, pero en un formato específico que exige quien lo recibe."
    },
    "template": {
      "term": "Plantilla",
      "definition": "Una plantilla es como una receta. Le dice al sistema exactamente cómo organizar sus datos —qué columnas, en qué orden, en qué formato— para que el archivo salga tal como lo necesita cada quien."
    },
    "engine": {
      "term": "Motor",
      "definition": "Un motor es el conjunto de reglas que arma el archivo EDD. Sabe cosas como 'si el resultado está por debajo del límite de detección, escribe <MDL en lugar del número.'"
    },
    "crosstable": {
      "term": "Tabla de equivalencias / Valores válidos",
      "definition": "Una tabla de equivalencias es un traductor. Su laboratorio llama a algo 'Mercurio' pero el estado quiere '7439-97-6'. La tabla de equivalencias hace esa traducción automáticamente."
    },
    "transform": {
      "term": "Transformación",
      "definition": "Una transformación es una regla que cambia los datos antes de que entren al archivo. Por ejemplo: 'Si el resultado es menor que el MDL, pon una marca U en la columna de calificador.'"
    },
    "fieldMapping": {
      "term": "Asignación de campos",
      "definition": "Una asignación de campos le dice al sistema de dónde tomar cada dato. Conecta los campos de datos de su laboratorio con las columnas que pide el regulador."
    }
  },
  "location": {
    "label": "Ubicación actual",
    "none": "Sin ubicación",
    "loading": "Cargando…",
    "default": "Predeterminada",
    "add": "+ Agregar ubicación",
    "addTitle": "Agregar una ubicación",
    "create": "Crear ubicación",
    "nameLabel": "Nombre de la ubicación",
    "namePlaceholder": "p. ej. Laboratorio Houston",
    "codeLabel": "Código (opcional)",
    "codeHint": "Un identificador corto para esta ubicación, p. ej. HOU.",
    "codePlaceholder": "p. ej. HOU",
    "added": "Ubicación \"{{name}}\" agregada"
  },
  "formats": {
    "title": "Todos sus EDD",
    "subtitle": "Sus propios EDD personalizados, la biblioteca de EDD estándar y cualquier formato específico de su sitio, todo en un solo lugar.",
    "subtitleAt": "Todos los EDD que puede usar en {{location}}: sus EDD personalizados más la biblioteca estándar.",
    "matchingFormats": "Total de EDD",
    "count": "{{count}} EDD",
    "builtInNote": "La biblioteca estándar viene integrada en Prisma EDD Builder; suba el EDDBuilderData.mdb de esta ubicación para agregar sus propios EDD personalizados.",
    "helpTitle": "ℹ️ ¿Es nuevo aquí? ¿Qué es un EDD?",
    "searchLabel": "Buscar",
    "searchPlaceholder": "Buscar EDD por nombre…",
    "filterType": "Tipo",
    "allTypes": "Todos los tipos",
    "filterSource": "Origen",
    "allSources": "Todos los orígenes",
    "filterFamily": "Categoría",
    "allFamilies": "Todas las categorías",
    "source": {
      "standard": "Estándar",
      "governmental": "Gubernamental",
      "lab": "Su laboratorio"
    },
    "type": {
      "custom": "Personalizado",
      "standard": "Estándar",
      "site_custom": "De sitio"
    },
    "statusChip": {
      "ready": "Listo para usar",
      "needs_crosstable": "Necesita configurar la tabla de equivalencias",
      "preview_only": "Solo vista previa"
    },
    "noMatchTitle": "Ningún EDD coincide",
    "noMatchBody": "Pruebe a borrar la búsqueda o los filtros.",
    "fields": "{{count}} campos",
    "openEditor": "Abrir en el editor →",
    "useThisFormat": "Usar este formato →",
    "uploadTitle": "Agregar los EDD personalizados de esta ubicación",
    "uploadBody": "Suba su EDDBuilderData.mdb para importar sus propios EDD.",
    "uploadBodyAt": "Suba el EDDBuilderData.mdb de {{location}} para importar sus propios EDD.",
    "dropTitle": "Arrastre aquí su EDDBuilderData.mdb",
    "dropBody": "o haga clic para examinar — solo archivos .mdb",
    "uploading": "Subiendo…",
    "chooseMdb": "Por favor elija un archivo .mdb.",
    "uploaded": "Se importó {{name}}"
  },
  "home": {
    "greeting": "Hola {{name}}",
    "techSubtitle": "Cree el archivo que envía a su cliente o regulador.",
    "adminSubtitle": "Cree un entregable o configure y administre su laboratorio.",
    "createTitle": "Crear un entregable",
    "generateTitle": "Generar un EDD",
    "createBody": "Elija el formato de su laboratorio, agregue la exportación de su orden de trabajo y lo revisaremos antes de enviar.",
    "createCta": "Comenzar",
    "generateCta": "Generar un EDD",
    "recentTitle": "Entregables recientes",
    "recentEmptyTitle": "Aún no hay entregables",
    "recentEmptyBody": "Cree el primero y aparecerá aquí para descargarlo con un solo clic.",
    "recentError": "No pudimos cargar sus entregables recientes. Revise su conexión e inténtelo de nuevo.",
    "viewAll": "Ver todo el historial",
    "reDownload": "Descargar de nuevo",
    "noResultYet": "No hay archivo para descargar",
    "adminToolsTitle": "Configurar y administrar su laboratorio",
    "cardFormatsTitle": "Formatos EDD",
    "cardFormatsBody": "Vea y edite los formatos EDD guardados de su laboratorio.",
    "cardStandardsTitle": "Normas",
    "cardStandardsBody": "Administre las normas de los reguladores que verifica.",
    "cardTeamTitle": "Equipo",
    "cardTeamBody": "Administre quién puede usar Prisma EDD Builder en su laboratorio.",
    "cardConnectorTitle": "Conector de Windows",
    "cardConnectorBody": "Conecte el asistente de Windows para la escritura en Promium.",
    "firstRunTitle": "¿Primera vez? Importe sus formatos EDD existentes",
    "firstRunBody": "Traiga sus formatos de la aplicación EDD Builder anterior. Cargue su EDDBuilderData.mdb e importaremos cada formato por usted.",
    "firstRunCta": "Importar mis formatos"
  },
  "onboarding": {
    "title": "¡Bienvenido! Configuremos {{location}}",
    "subtitle": "Traeremos los formatos EDD personalizados de su laboratorio desde su computadora de Promium. Solo toma un minuto y no necesita conocimientos de computación.",
    "step1Label": "Lo que necesita",
    "step2Label": "Subir",
    "step3Label": "Listo",
    "explainTitle": "Lo que vamos a hacer",
    "explainBody": "Su laboratorio ya tiene sus formatos EDD configurados en el programa anterior \"EDD Builder\" de Promium / Element. Solo necesitamos algunos archivos de esa computadora para que aquí aparezcan los mismos formatos.",
    "whereTitle": "Dónde están los archivos",
    "whereBody": "En la computadora con Windows que ejecuta Promium / Element, abra la carpeta de instalación de EDD Builder. Suele estar aquí:",
    "filesTitle": "Los archivos que debe buscar",
    "fileMdb": "Los formatos EDD personalizados de su laboratorio — este es el importante.",
    "fileEddlib": "La biblioteca de formatos estándar (ya la tenemos incluida).",
    "fileEddcustom": "Cualquier personalización hecha solo para su laboratorio.",
    "required": "Obligatorio",
    "optional": "Opcional",
    "namingHint": "Los nombres de los archivos son exactamente EDDBuilderData.mdb, eddlib.dll y eddcustom.dll. Si no los ve, pregunte a quien instaló Promium dónde está la carpeta de EDD Builder.",
    "startUpload": "Siguiente: suba los archivos",
    "uploadTitle": "Suelte sus archivos aquí",
    "uploadBody": "Arrastre todos los archivos que encontró sobre el recuadro de abajo a la vez — o haga clic para buscarlos. Puede incluir el .mdb y los archivos .dll juntos.",
    "dropTitle": "Arrastre aquí sus archivos de Promium",
    "dropBrowse": "o haga clic para buscar",
    "dropAria": "Suba sus archivos de EDD Builder de Promium",
    "uploading": "Configurando sus formatos…",
    "needMdb": "Por favor incluya su archivo EDDBuilderData.mdb — ese es el que tiene sus formatos.",
    "noRecognizedFiles": "Ninguno de esos archivos es reconocido. Suelte el EDDBuilderData.mdb (y opcionalmente los archivos .dll) de su carpeta de instalación de Promium.",
    "fileTooLarge": "\"{{name}}\" es demasiado grande para cargar aquí ({{size}} MB; límite {{limit}} MB). Puede ser el archivo equivocado — la base de datos de configuración suele ser de unos pocos MB.",
    "dllAck": "Entendido — recibimos {{names}}. La biblioteca de formatos estándar ya está incluida, así que solo los guardaremos.",
    "libraryNote": "Para que lo sepa: la biblioteca EDD estándar ya está incluida. Su EDDBuilderData.mdb es el que trae los formatos hechos solo para su laboratorio.",
    "back": "Atrás",
    "doneTitle_one": "¡Todo listo! Configuramos {{count}} formato para usted",
    "doneTitle_other": "¡Todo listo! Configuramos {{count}} formatos para usted",
    "doneBody": "Sus formatos están listos. Puede empezar a crear el archivo que envía a su cliente o regulador cuando quiera.",
    "summaryFormats_one": "{{count}} formato importado",
    "summaryFormats_other": "{{count}} formatos importados",
    "summaryEngines_one": "{{count}} formato personalizado decodificado de su eddcustom.dll ({{transforms}} reglas recuperadas)",
    "summaryEngines_other": "{{count}} formatos personalizados decodificados de su eddcustom.dll ({{transforms}} reglas recuperadas)",
    "summarySchemas": "Esquemas de análisis encontrados: {{values}}",
    "verifyPassed": "Todas las comprobaciones pasaron",
    "verifyFailedTitle": "Algunas comprobaciones requieren revisión",
    "goGenerate": "Generar un EDD",
    "goHome": "Ir al inicio"
  },
  "email": {
    "title_one": "Enviar {{count}} entregable por correo",
    "title_other": "Enviar {{count}} entregables por correo",
    "intro_one": "Enviaremos como adjunto el {{count}} entregable que eligió.",
    "intro_other": "Enviaremos como adjuntos los {{count}} entregables que eligió.",
    "toLabel": "Enviar a",
    "toHint": "Puede escribir más de uno — sepárelos con una coma o un espacio.",
    "toPlaceholder": "nombre@cliente.com, nombre@regulador.gov",
    "toInvalid": "Por favor escriba al menos una dirección de correo válida.",
    "subjectLabel": "Asunto (opcional)",
    "subjectPlaceholder": "Sus archivos EDD",
    "messageLabel": "Mensaje (opcional)",
    "messagePlaceholder": "Agregue una nota breve para el destinatario…",
    "send": "Enviar",
    "sent_one": "Enviado a {{to}}.",
    "sent_other": "Se enviaron {{count}} archivos a {{to}}.",
    "noFiles": "Los entregables seleccionados aún no tienen archivos para enviar.",
    "notConfigured": "El correo aún no está configurado. Pídale a su administrador que active el correo y entonces podrá enviar entregables directamente desde aquí. Mientras tanto, puede descargar los archivos y adjuntarlos usted mismo.",
    "selectAll": "Seleccionar todos los entregables",
    "selectOne": "Seleccionar {{name}}",
    "selectionLabel": "Entregables seleccionados",
    "selectedCount_one": "{{count}} entregable seleccionado",
    "selectedCount_other": "{{count}} entregables seleccionados",
    "clearSelection": "Limpiar",
    "emailSelected": "Enviar por correo los seleccionados"
  },
  "wizard": {
    "title": "Crear un entregable",
    "exit": "Cancelar",
    "back": "Atrás",
    "next": "Siguiente",
    "backTo": "Volver a {{step}}",
    "nextTo": "Continuar a {{step}}",
    "step1Label": "Formato",
    "step2Label": "Sus datos",
    "step3Label": "Revisión",
    "step4Label": "Descarga",
    "step1Title": "¿Qué entregable?",
    "step1Body": "Elija uno de los formatos guardados de su laboratorio.",
    "searchFormats": "Buscar en sus formatos…",
    "noFormatsTitle": "Aún no hay formatos",
    "noFormatsBody": "Su laboratorio no tiene formatos guardados. Agregue uno desde la biblioteca de formatos para empezar.",
    "goToLibrary": "Abrir la biblioteca de formatos",
    "loadingFormats": "Cargando sus formatos…",
    "loadFormatsErrorTitle": "No se pudieron cargar sus formatos",
    "loadFormatsErrorBody": "No pudimos contactar al servidor para listar sus formatos guardados. Revise su conexión e inténtelo de nuevo.",
    "retry": "Reintentar",
    "wrongFileType": "Ese tipo de archivo no es compatible. Suelte una exportación .mdb o un .zip de archivos Out*.csv.",
    "schemaLabel": "Esquema de datos",
    "schemaHint": "Elija el esquema de análisis que usa esta orden de trabajo.",
    "step2Title": "Agregue los datos de su orden de trabajo",
    "step2Body": "Suelte la exportación que obtuvo de Element o Promium.",
    "dropTitle": "Arrastre aquí su exportación de Element/Promium (.mdb)",
    "dropBrowse": "o busque",
    "dropZipHint": "¿Tiene un zip de archivos Out*.csv? También puede soltarlo o buscarlo.",
    "uploadingFile": "Cargando…",
    "fileReady": "Usando {{name}}",
    "changeFile": "Elegir otro archivo",
    "sampleLink": "¿No tiene archivo a mano? Pruebe con datos de ejemplo (solo vista previa)",
    "sampleSelected": "Usando datos de ejemplo — solo vista previa, no para envío.",
    "useRealFile": "Usar un archivo real en su lugar",
    "step3Title": "Lo revisamos",
    "checking": "Revisando su entregable…",
    "readyToSend": "✓ Listo para enviar",
    "readyBody": "Todo se ve bien. Continúe para descargar su archivo.",
    "thingsToFix_one": "⚠ {{count}} cosa por corregir antes de enviar",
    "thingsToFix_other": "⚠ {{count}} cosas por corregir antes de enviar",
    "fixBody": "Revise los elementos a continuación y, si es necesario, pida a su responsable de control de calidad que ajuste el formato. Aún puede descargar para inspeccionar.",
    "rowSummary": "{{sx}} resultados de muestra · {{qa}} resultados de control de calidad",
    "checkFailed": "No pudimos terminar la revisión.",
    "step4Title": "Descarga",
    "step4ReadyBody": "Su entregable está listo.",
    "downloadFile": "Descargar",
    "whatNext": "Adjunte este archivo a su envío a su cliente o regulador.",
    "createAnother": "Crear otro",
    "pickFormatFirst": "Elija un formato para continuar.",
    "addDataFirst": "Agregue sus datos para continuar."
  },
  "auth": {
    "appName": "Prisma EDD Builder",
    "signInSubtitle": "Inicie sesión para crear sus entregables electrónicos de datos.",
    "email": "Correo electrónico",
    "emailPlaceholder": "usted@laboratorio.com",
    "password": "Contraseña",
    "passwordPlaceholder": "••••••••",
    "signIn": "Iniciar sesión",
    "forgotPassword": "¿Olvidó su contraseña?",
    "noAccount": "¿No tiene cuenta?",
    "createOne": "Crear una",
    "signedIn": "Sesión iniciada.",
    "createTitle": "Cree su cuenta",
    "createSubtitle": "Empiece a crear formatos EDD para su laboratorio.",
    "newPasswordPlaceholder": "Al menos 8 caracteres",
    "passwordHint": "Al menos 8 caracteres.",
    "orgName": "Nombre de la organización (opcional)",
    "orgNamePlaceholder": "Laboratorio Ambiental Acme",
    "orgNameHint": "Déjelo en blanco para crear una organización personal.",
    "createAccount": "Crear cuenta",
    "accountCreated": "Cuenta creada.",
    "haveAccount": "¿Ya tiene una cuenta?"
  },
  "setPassword": {
    "title": "Establezca su nueva contraseña",
    "subtitle": "Su cuenta se creó con una contraseña temporal. Elija una nueva para terminar de iniciar sesión.",
    "newPassword": "Nueva contraseña",
    "confirmPassword": "Confirme la nueva contraseña",
    "mismatch": "Las contraseñas no coinciden.",
    "submit": "Establecer contraseña y continuar"
  },
  "forgotPassword": {
    "title": "Restablezca su contraseña",
    "subtitle": "Escriba su correo electrónico y le enviaremos un enlace para restablecer su contraseña.",
    "submit": "Enviar enlace de restablecimiento",
    "sent": "Si ese correo tiene una cuenta, le hemos enviado un enlace de restablecimiento.",
    "backToLogin": "Volver a iniciar sesión"
  },
  "resetPassword": {
    "title": "Elija una nueva contraseña",
    "subtitle": "Escriba una nueva contraseña para su cuenta.",
    "newPassword": "Nueva contraseña",
    "confirmPassword": "Confirme la nueva contraseña",
    "mismatch": "Las contraseñas no coinciden.",
    "submit": "Restablecer contraseña",
    "success": "Su contraseña ha sido restablecida. Inicie sesión.",
    "invalidLink": "Este enlace de restablecimiento no es válido o ha caducado.",
    "requestNew": "Solicitar un nuevo enlace de restablecimiento"
  },
  "footer": {
    "copyright": "© 2026 Prisma EDD Builder"
  },
  "templates": {
    "title": "Biblioteca de formatos",
    "subtitle": "Los 196 formatos EDD estándar — 35 formatos de inicio + 161 formatos de la Biblioteca Estándar. Agregue cualquiera a los formatos de su laboratorio.",
    "formats_one": "{{count}} formato",
    "formats_other": "{{count}} formatos",
    "matchingFormats": "Formatos coincidentes",
    "searchPlaceholder": "Nombre, clase o sistema…",
    "family": "Familia",
    "allFamilies": "Todas las familias",
    "output": "Salida",
    "allOutputs": "Todas las salidas",
    "recoverability": "Recuperabilidad",
    "testStatus": "Estado de prueba",
    "allKinds": "Todos los tipos",
    "configTemplates": "Plantillas de configuración",
    "standardLibrary": "Biblioteca estándar",
    "inMyMdb": "En mi archivo .mdb cargado",
    "noMatchTitle": "Ningún formato coincide",
    "noMatchBody": "Pruebe una búsqueda más amplia o limpie los filtros.",
    "hasConfig": "configuración",
    "fields_one": "{{count}} campo",
    "fields_other": "{{count}} campos"
  },
  "configs": {
    "title": "Formatos EDD",
    "subtitle": "Los formatos EDD editables de su laboratorio.",
    "newFromDescription": "Nuevo desde descripción",
    "newConfig": "+ Nuevo formato",
    "colName": "Nombre",
    "colFormat": "Salida",
    "colFields": "Columnas",
    "colVersion": "Versión",
    "colUpdated": "Actualizado",
    "querydefTitle": "Almacenado como Jet QueryDef — solo lectura",
    "querydef": "querydef",
    "created": "Formato creado.",
    "cloned": "Formato clonado.",
    "deleted": "Formato eliminado.",
    "emptyTitle": "Aún no hay formatos",
    "emptyBody": "Traiga sus formatos del EDD Builder anterior, parta de un formato estándar o cree uno en blanco.",
    "emptyImport": "Importar de la app anterior",
    "emptyBrowseLibrary": "Partir de un formato estándar",
    "createBlank": "Crear un formato en blanco",
    "newModalTitle": "Nuevo formato",
    "nameLabel": "Nombre",
    "newModalHint": "Crea un formato CSV en blanco. Puede cambiar todo en el editor de formatos, o partir de un formato estándar de la biblioteca.",
    "cloneModalTitle": "Clonar formato",
    "cloneNameLabel": "Nombre del nuevo formato",
    "deleteModalTitle": "Eliminar formato",
    "deletePrompt": "¿Eliminar <0>{{name}}</0>? Esta acción no se puede deshacer.",
    "copySuffix": "(copia)",
    "defaultName": "Nuevo EDD",
    "validTemplate": "Plantilla válida",
    "validTemplateTitle": "Todos los casos de prueba pasaron con la versión actual de este EDD.",
    "renamedNotice": "Ya existe un EDD llamado \"{{requested}}\"; este se creó como \"{{created}}\"."
  },
  "generate": {
    "title": "Crear un entregable (avanzado)",
    "subtitle": "Ejecute un formato guardado contra sus datos y descargue el entregable en cualquier salida. Para la versión guiada, use Crear un entregable.",
    "jobHistory": "Historial",
    "step1": "1. Formato y datos",
    "config": "Formato",
    "selectConfig": "Seleccione un formato…",
    "loadingConfigs": "Cargando sus formatos…",
    "noConfigsHint": "Aún no tiene formatos — agregue uno desde la biblioteca de formatos.",
    "browseTemplates": "Explorar la biblioteca de formatos",
    "source": "Sus datos",
    "sourceHint": "Los datos de ejemplo son solo para vista previa — no para envío.",
    "synthetic": "Datos de ejemplo (solo vista previa)",
    "sampleRows": "Filas de ejemplo",
    "uploadTitle": "Arrastre aquí la exportación de su orden de trabajo",
    "uploadSublabel": "o haga clic para buscar su exportación de Element/Promium.",
    "uploadHint": ".mdb (output.mdb) o un zip con los archivos Out*.csv.",
    "uploading": "Cargando…",
    "step2": "2. Salida",
    "delimiterSeparator": "Separador del delimitado",
    "separatorHint": "Se aplica a la salida delimitada (CSV).",
    "runTransforms": "Ejecutar los cálculos y reglas del formato",
    "step3": "3. Revisar antes de enviar",
    "aboutValidation": "Acerca de revisar antes de enviar",
    "aboutValidationBody": "Comprueba las filas generadas contra una norma de regulador — campos obligatorios, pertenencia a valores válidos, tipos de datos y formatos de fecha/número/nombre de columna — e informa de cualquier problema en lenguaje claro. Deje la norma en detección automática para que coincida por la familia del formato.",
    "validateOutput": "Revisar la salida contra una norma de regulador",
    "regulatorSpec": "Norma del regulador",
    "loadingSpecs": "Cargando normas…",
    "autoDetectHint": "Deje en detección automática para que coincida por familia.",
    "autoDetect": "Detección automática desde el formato",
    "runName": "Nombre del entregable (opcional)",
    "runNamePlaceholder": "Por defecto, el nombre del formato",
    "runGeneration": "Crear entregable",
    "runningEngine": "Creando su entregable…",
    "openFullDetail": "Abrir detalle completo",
    "downloadZip": "Descargar .zip",
    "downloadThisItem": "Descargar este elemento",
    "pickConfig": "Elija un formato para usar.",
    "pickFormat": "Elija al menos una salida.",
    "uploaded": "Cargado {{name}}.",
    "complete": "Entregable listo.",
    "failed": "No se pudo crear el entregable.",
    "rowSummary": "{{sx}} resultados de muestra · {{qa}} resultados de QC",
    "formats": {
      "delimited": "Delimitado (CSV/TSV/PSV)",
      "excel": "Excel (.xlsx)",
      "xml": "XML",
      "access2": "Access 2000 (.mdb)",
      "access7": "Access 2007 (.accdb)"
    },
    "separators": {
      "comma": "Coma (,)",
      "tab": "Tabulación",
      "pipe": "Barra vertical (|)"
    },
    "readiness": {
      "loaded": "Tablas cruzadas cargadas ✓ ({{count}} tablas)",
      "partial": "Parcial — faltan: {{missing}}",
      "none": "No se han cargado tablas cruzadas",
      "fallback": "Usando valores predeterminados incluidos (sin carga del laboratorio)",
      "manageLink": "Gestionar tablas cruzadas en el Perfil"
    }
  },
  "jobs": {
    "title": "Historial",
    "subtitle": "Cada entregable que ha creado, los más recientes primero.",
    "newRun": "Crear un entregable",
    "newBatch": "Varias órdenes de trabajo",
    "colName": "Nombre",
    "colKind": "Tipo",
    "colStatus": "Estado",
    "colConfig": "Formato",
    "colItems": "Elementos",
    "colFormats": "Salida",
    "colCreated": "Creado",
    "unnamed": "(sin nombre)",
    "itemsFailed": "({{count}} con error)",
    "deleted": "Entregable eliminado.",
    "emptyTitle": "Aún no hay entregables",
    "emptyBody": "Cree un entregable desde uno de sus formatos para verlo aquí.",
    "emptyCreateFirst": "Cree su primer entregable",
    "deleteModalTitle": "Eliminar entregable",
    "deletePrompt": "¿Eliminar <0>{{name}}</0> y su paquete de resultados? Esta acción no se puede deshacer.",
    "thisJob": "este entregable",
    "backToHistory": "← Historial",
    "downloadAll": "Descargar todo (.zip)",
    "downloadItem": "Descargar elemento",
    "unnamedJob": "(entregable sin nombre)",
    "detailConfig": "Formato",
    "detailSource": "Datos",
    "detailFormats": "Salida",
    "detailItems": "Elementos",
    "detailCreated": "Creado",
    "detailUpdated": "Actualizado",
    "itemsOk": "{{done}}/{{total}} correctos",
    "itemsFailedSuffix": " · {{count}} con error",
    "sampleQcRows": "{{sx}} resultados de muestra · {{qa}} resultados de QC"
  },
  "gettingStarted": {
    "title": "Primeros pasos",
    "whatIsEdd": "¿Qué es un EDD?",
    "whatIsEddBody": "Un EDD (entregable electrónico de datos) es una exportación con formato de resultados de laboratorio — CSV, Excel, Access o XML — que un laboratorio envía a un cliente o regulador. Prisma EDD Builder le permite crear, ejecutar y validar estos formatos sin escribir código.",
    "subtitle": "De la carga al entregable en siete pasos. Cada paso enlaza con la pantalla que lo realiza.",
    "step1Title": "Elija o clone una plantilla",
    "step1Body": "Explore el catálogo de 196 formatos EDD — 35 plantillas configurables más 161 formatos de la Biblioteca Estándar. Abra una para inspeccionar sus campos, transformaciones y tablas cruzadas, luego clónela en su propia configuración editable.",
    "step1Cta": "Explorar plantillas",
    "step2Title": "Cargue sus datos (opcional)",
    "step2Body": "La generación usa por defecto filas Out* sintéticas y deterministas, así que puede obtener una vista previa sin cargar nada. Para producir un entregable real, cargue un output.mdb de Element (uno por orden de trabajo) o un zip de archivos Out*.csv en la pantalla de Generar.",
    "step2Cta": "Ir a Generar",
    "step3Title": "Asigne campos y defina el formato de salida",
    "step3Body": "En el editor de configuración, asigne cada columna de salida (encabezado) a un campo de origen de Element y elija el formato de salida (delimitado, Excel, Access o XML). Los encabezados no deben contener espacios — se convierten en encabezados CSV, nombres de campo de Access, etiquetas XML y los identificadores que referencian sus transformaciones.",
    "step3Cta": "Abrir Mis configuraciones",
    "step4Title": "Cruce de tablas y transformaciones",
    "step4Body": "Active las tablas cruzadas para traducir los valores de Element (analito, matriz, unidades…) a los códigos de valores válidos del regulador. Agregue transformaciones Jet UPDATE ordenadas para cálculos que la cuadrícula no puede hacer (p. ej., marcar resultados por debajo del límite de detección). Las columnas auxiliares ocultas siguen disponibles para las transformaciones pero se omiten del archivo.",
    "step4Cta": "Editar una configuración",
    "step5Title": "Vista previa y generación",
    "step5Body": "Ejecute la configuración contra la fuente elegida para construir las tablas SXDATA (muestras) y QADATA (CC), luego genere el entregable. Inspeccione una muestra en línea y descargue el paquete .zip.",
    "step5Cta": "Generar un EDD",
    "step6Title": "Valide contra una especificación de regulador",
    "step6Body": "Antes de enviar, valide la salida contra una especificación de regulador — campos obligatorios, valores válidos, tipos y formatos de fecha/número — con mensajes en lenguaje claro (sin códigos de error Jet). También puede comprobar la desviación de una configuración respecto a una especificación del registro.",
    "step6Cta": "Abrir registro de especificaciones",
    "step7Title": "Descargue o reescriba",
    "step7Body": "Descargue los archivos generados o — para EDD basados en QueryDef que el motor en la nube no puede escribir — encole una reescritura a un procesador Windows que se ejecute en su máquina Promium, que escribe QueryDefs Jet nativos y devuelve el archivo.",
    "step7Cta": "Procesador Windows",
    "rulesTitle": "Reglas clave para recordar",
    "rule1Strong": "Los encabezados no llevan espacios.",
    "rule1Body": "Se convierten en encabezados de columna, nombres de campo de Access, etiquetas XML e identificadores SQL.",
    "rule2Strong": "Las transformaciones son sentencias Jet UPDATE",
    "rule2Body": "sobre SXDATA / QADATA, que referencian columnas por su encabezado.",
    "rule3Strong": "Los EDD de archivo único",
    "rule3Body": "necesitan que las cuadrículas SX y QA compartan el mismo número de campos, orden y encabezados.",
    "rule4Strong": "Las configuraciones QueryDef son de solo lectura",
    "rule4Body": "aquí y necesitan el procesador Windows para reescribir."
  },
  "ai": {
    "findByDescription": "Encontrar una plantilla por descripción",
    "localMode": "modo local",
    "localModeTitle": "Defina ANTHROPIC_API_KEY para resultados más inteligentes",
    "notConfigured": "IA no configurada",
    "describePlaceholder": "Describa lo que necesita — p. ej. 'EDD ESdat de suelo y agua para NSW EPA'",
    "useThis": "Usar esta",
    "hasConfig": "tiene configuración",
    "notConfiguredBanner": "La IA no está configurada — defina ANTHROPIC_API_KEY para resultados más inteligentes. La búsqueda determinista sigue funcionando.",
    "interpretedAs": "Interpretado como:",
    "noStrongMatches": "No se encontraron coincidencias fuertes. Pruebe otra descripción o explore las 196 plantillas a continuación.",
    "createdFromTemplate": "Configuración \"{{name}}\" creada a partir de la plantilla.",
    "draftTitle": "Crear EDD desde una descripción",
    "draftSubtitle": "Describa el EDD que necesita en lenguaje claro. La IA propondrá una configuración completa que usted revisa y aprueba.",
    "draftNotConfigured": "IA no configurada — defina ANTHROPIC_API_KEY para resultados más inteligentes. La coincidencia determinista de patrones aún producirá un borrador útil.",
    "draftLocalMode": "Ejecutando en modo local — defina ANTHROPIC_API_KEY para borradores más inteligentes y conscientes de la descripción.",
    "describeYourEdd": "Describa su EDD",
    "draftDescPlaceholder": "p. ej. Un EDD compatible con ESdat para resultados de suelo y agua en formato CSV con asignación de analitos por tabla cruzada y una transformación de calificador de no detectado.",
    "startFromTemplate": "Partir de una plantilla (opcional — pegue el ID o nombre de la plantilla)",
    "startFromTemplatePlaceholder": "p. ej. esdat_csv o déjelo en blanco",
    "buildDraft": "Crear borrador",
    "proposal": "Propuesta",
    "buildSteps": "Pasos de creación",
    "validationIssues": "Problemas de validación ({{count}})",
    "feedbackHistory": "Historial de comentarios",
    "refineProposal": "Refinar la propuesta",
    "refinePlaceholder": "p. ej. añadir una transformación de calificador, usar separador de barra vertical en su lugar",
    "refine": "Refinar",
    "createThisConfig": "Crear esta configuración",
    "configCreated": "Configuración \"{{name}}\" creada.",
    "notConfiguredFuzzy": "IA no configurada — defina ANTHROPIC_API_KEY para resultados más inteligentes. La coincidencia difusa/CAS sigue funcionando.",
    "notConfiguredMapping": "IA no configurada — defina ANTHROPIC_API_KEY para resultados más inteligentes. La asignación determinista sigue funcionando.",
    "notConfiguredPattern": "IA no configurada — defina ANTHROPIC_API_KEY para resultados más inteligentes. Las sugerencias basadas en patrones siguen funcionando.",
    "crossTitle": "Coincidencia de tabla de valores con IA",
    "xtableLabel": "Tabla X",
    "elementValuesLabel": "Valores de Element a coincidir (separados por comas o saltos de línea)",
    "elementValuesPlaceholder": "p. ej. Benceno, Tolueno, Etilbenceno",
    "matchValuesIn": "Coincidir {{values}} en {{xtable}}",
    "matchValuesGeneric": "valores",
    "matchValueCount_one": "{{count}} valor",
    "matchValueCount_other": "{{count}} valores",
    "kind": "Tipo:",
    "noMatchFound": "No se encontró coincidencia para:",
    "matchCount_one": "{{count}} coincidencia",
    "matchCount_other": "{{count}} coincidencias",
    "approveAll": "Aprobar todo",
    "applyApproved": "Aplicar aprobadas ({{count}})",
    "colElementValue": "Valor de Element",
    "colMatchedCode": "Código coincidente",
    "colLabel": "Etiqueta",
    "colConfidence": "Confianza",
    "colMethod": "Método",
    "matchesApproved_one": "{{count}} coincidencia aprobada.",
    "matchesApproved_other": "{{count}} coincidencias aprobadas.",
    "mappingTitle": "Asignación de campos con IA",
    "proposeMapping": "Proponer asignación",
    "validationIssuesInProposal": "Problemas de validación en la propuesta:",
    "unmappedHeadings": "Encabezados sin asignar (no se encontró origen):",
    "perFieldConfidence": "Confianza por campo",
    "colGrid": "Cuadrícula",
    "colHeading": "Encabezado",
    "colMapsTo": "Se asigna a",
    "colReason": "Razón",
    "mappingRefinePlaceholder": "Refinar: p. ej. 'intercambiar LabID y SampleName'",
    "approveMapping": "Aprobar asignación",
    "discard": "Descartar",
    "mappingApplied": "Asignación de IA aplicada.",
    "recordingTitle": "Grabando…",
    "listening": "Escuchando…",
    "confidenceTitle": "Confianza: {{pct}}%",
    "transformTitle": "Asistente de transformaciones con IA",
    "describeTransform": "Describa una transformación en lenguaje claro",
    "transformInstructionPlaceholder": "p. ej. si el resultado está por debajo del MDL, ponga Qualifier en U y antepoga < al Result",
    "generateSql": "Generar SQL",
    "generatedSql": "SQL generado",
    "attempt": "(intento {{n}})",
    "dryRunFailed": "La prueba falló.",
    "before": "Antes",
    "after": "Después",
    "approveAndAdd": "Aprobar y agregar",
    "couldNotGenerate": "No se pudo generar una transformación válida.",
    "transformGenerationFailed": "La generación de la transformación falló.",
    "transformAdded": "Transformación agregada.",
    "suggestedTransforms": "Transformaciones sugeridas para esta configuración",
    "add": "+ Agregar",
    "suggestionAdded": "\"{{title}}\" agregada.",
    "noChanges": "Sin cambios — la propuesta coincide con la configuración actual.",
    "fieldChanges": "Cambios de campos ({{n}})",
    "transformChanges": "Cambios de transformaciones ({{n}})",
    "crosstableChanges": "Cambios de tabla de valores ({{n}})",
    "settingsChanges": "Cambios de ajustes ({{n}})",
    "diffColOp": "Op",
    "diffColGrid": "Cuadrícula",
    "diffColHeading": "Encabezado",
    "diffColDetail": "Detalle",
    "diffColName": "Nombre",
    "diffColXtable": "Tabla X",
    "diffColField": "Campo",
    "diffColKey": "Clave",
    "diffColBefore": "Antes",
    "diffColAfter": "Después",
    "sqlModified": "SQL modificado"
  },
  "mic": {
    "start": "Iniciar entrada por voz",
    "stop": "Terminar la grabación",
    "micLabel": "🎙 Micrófono",
    "stopLabel": "⏹ Terminar grabación",
    "live": " (en vivo)",
    "noAudio": "No capté ningún audio — revisa tu micrófono e inténtalo de nuevo.",
    "noSpeech": "No pude entender lo que dijiste. Inténtalo de nuevo y habla un poco más fuerte.",
    "processing": "Transcribiendo…"
  },
  "builder": {
    "chatLabel": "Chat del generador de EDD",
    "emptyState": "Cuéntame qué archivo necesitas, o suelta un ejemplo, una especificación o cualquier documento de referencia. Te haré algunas preguntas y luego crearé un borrador que podrás revisar.",
    "thinking": "El asistente está pensando…",
    "readyTitle": "Tu borrador está listo.",
    "readyBody": "Ya completé los campos. Ábrelo en el editor para revisarlo y terminarlo.",
    "openInEditor": "Abrir en el editor"
  },
  "guided": {
    "confidenceLabel": "Qué tan seguro estoy",
    "clarifyTitle": "Un par de cosas que conviene revisar primero",
    "clarifyHint": "No estoy del todo seguro aquí — por favor léelas antes de confirmar.",
    "looksRight": "Se ve bien",
    "proposed": "Sugiero",
    "changeIt": "Cambiarlo",
    "editLabel": "Escribe la respuesta que quieres",
    "columnsTitle": "Columnas propuestas",
    "editColumns": "Editar las columnas",
    "editColumnsLabel": "Un nombre de columna por línea",
    "editColumnsHint": "Escribe las columnas que quieres, una por línea, en orden.",
    "colName": "Columna",
    "customLabel": "O escribe tu propia respuesta",
    "customPlaceholder": "Escribe tu respuesta…",
    "confirm": "Confirmar",
    "useColumns": "Usar estas columnas",
    "flowToggleLabel": "¿Cómo lo creamos?",
    "flowQuick": "Rápido",
    "flowStep": "Paso a paso",
    "foundTitle": "Lo que encontré y lo que todavía necesito",
    "foundIntro": "En tus archivos encontré esto:",
    "surrogates": "Surrogado",
    "internalStandards": "Estándar interno",
    "qcTypes": "Tipo de QC",
    "missingIntro": "Para terminar, todavía necesito:",
    "missingHint": "Agrégalos en el panel de archivos y los tomaré.",
    "openInEditor": "Abrir en el editor",
    "barHintQuick": "Confirma cada tarjeta de arriba. Cuando todo se vea bien, tendré tu EDD listo.",
    "barHintStep": "Responde la pregunta de arriba y paso a la siguiente.",
    "quickEmpty": "Nada que revisar por ahora — cuéntame más y agrego las siguientes preguntas.",
    "quickHeading": "Revisa cada una de estas y confirma. Puedes cambiar cualquiera.",
    "doneTitle": "Todo listo — tu EDD está preparado",
    "doneBody": "Ya completé todo. Ábrelo en el editor para previsualizar con tus datos y terminar.",
    "waitingTitle": "Trabajando en ello",
    "waitingBody": "Cuéntame un poco más a la derecha y preparo la siguiente pregunta.",
    "entryTitle": "Asistente guiado",
    "entryBody": "Te llevo paso a paso, con palabras sencillas, y completo todo para que lo revises. Ideal si no sabes por dónde empezar.",
    "classicTitle": "Chat de IA clásico",
    "classicBody": "Conversa con la IA de forma abierta — escribe o habla con libertad y va creando mientras avanzas.",
    "chooserTitle": "¿Cómo lo creamos?",
    "chooserSubtitle": "Elige lo que te resulte más fácil — puedes cambiar cuando quieras.",
    "chooserQuick": "Revisión rápida",
    "chooserQuickBody": "Te muestro todas mis preguntas a la vez para que las confirmes rápido.",
    "chooserStep": "Un paso a la vez",
    "chooserStepBody": "Hago una pregunta sencilla a la vez y espero cada respuesta.",
    "thinkingTitle": "El asistente está pensando…",
    "thinkingBody": "Estoy trabajando en esto — el siguiente paso aparecerá aquí en un momento.",
    "needsInput": "Necesita tu ayuda",
    "requirements": {
      "title": "Lo que has decidido hasta ahora",
      "hint": "Cada elección que entró en este EDD y de dónde vino. Cambia cualquiera y rehago el resto.",
      "listLabel": "Decisiones tomadas hasta ahora",
      "edit": "Editar",
      "editAria": "Cambiar «{{label}}»",
      "sourceTitle": "De dónde vino esto",
      "source": {
        "user": "Tú elegiste",
        "ai_inferred": "Yo sugerí",
        "from_spec": "De tu especificación",
        "from_cloned_config": "De un formato existente",
        "ai": "Yo sugerí",
        "example": "De tu archivo de ejemplo",
        "output": "De tu archivo de ejemplo",
        "spec": "De tu especificación",
        "clone": "De un formato existente",
        "unknown": "Decidido"
      }
    },
    "validate": {
      "title": "Revisa antes de terminar",
      "intro": "Buscaré cualquier cosa que un regulador rechazaría — códigos sin mapear, valores obligatorios que falten, formatos incorrectos — antes de que lo entregues.",
      "check": "Ejecutar la revisión",
      "recheck": "Ejecutarla de nuevo",
      "running": "Revisando tu EDD…",
      "issuesLabel": "Problemas encontrados",
      "okBadge": "Todo correcto",
      "ok": "Se ve bien — no se encontraron problemas.",
      "severityError": "Hay que corregir",
      "severityWarning": "Atención",
      "knownGoodTitle": "Demuestra que coincide con mi archivo de referencia",
      "knownGoodHint": "Suelta una orden de trabajo y el archivo que tu regulador ya aceptó, y confirmaré que este EDD lo reproduce exactamente.",
      "inputLabel": "Tus datos de orden de trabajo",
      "inputHint": "La exportación de Element a procesar (CSV/zip o Access).",
      "expectedLabel": "Tu archivo de referencia",
      "expectedHint": "El entregable que el regulador ya aceptó.",
      "matchBadge": "Coincide",
      "matches": "Este EDD reproduce tu archivo de referencia exactamente.",
      "noMatchBadge": "Todavía no",
      "noMatch": "Aún no coincide con tu archivo de referencia — aquí está la primera diferencia:",
      "fileMatch": "Coincide",
      "fileDiff": "Difiere"
    },
    "resume": {
      "title": "Retoma tu última creación",
      "body": "Tienes un EDD en progreso: {{name}}.",
      "untitled": "una creación sin nombre",
      "action": "Retomar",
      "gone": "Esa creación ya no está disponible — empezando de nuevo."
    },
    "clone": {
      "title": "Empezar desde un formato existente",
      "hint": "Copia uno de tus EDD guardados como punto de partida y cambia solo lo que sea distinto.",
      "listLabel": "Tus formatos guardados",
      "start": "Empezar desde este"
    }
  },
  "validation": {
    "title": "Validación contra especificación del regulador",
    "passes": "✓ Aprueba",
    "noIssues": "✓ Sin problemas",
    "errors_one": "{{count}} error",
    "errors_other": "{{count}} errores",
    "warnings_one": "{{count}} advertencia",
    "warnings_other": "{{count}} advertencias",
    "showDetails": "Mostrar detalles",
    "hideDetails": "Ocultar detalles",
    "noSpecMatched": "No se encontró ninguna especificación de regulador. Elija una especificación para ejecutar la validación de formato.",
    "checkedSummary_one": "Se verificó {{rows}} fila en {{fields}} campos.",
    "checkedSummary_other": "Se verificaron {{rows}} filas en {{fields}} campos.",
    "row": "fila {{row}}",
    "value": "valor “{{value}}”",
    "codes": {
      "missing_required": "Falta el campo obligatorio \"{{field}}\" en la salida.",
      "bad_value": "El valor “{{value}}” para \"{{field}}\" no es un valor permitido.",
      "bad_type": "El valor “{{value}}” para \"{{field}}\" tiene un tipo de dato incorrecto.",
      "bad_date": "El valor “{{value}}” para \"{{field}}\" no es una fecha válida.",
      "bad_number": "El valor “{{value}}” para \"{{field}}\" no es un número válido.",
      "bad_pattern": "El valor “{{value}}” para \"{{field}}\" no coincide con el formato requerido.",
      "heading_space": "El encabezado \"{{field}}\" contiene espacios — los encabezados no deben tener ninguno.",
      "heading_dup": "El encabezado \"{{field}}\" está duplicado — los encabezados deben ser únicos.",
      "empty_heading": "A un campo le falta su encabezado.",
      "extra_field": "El campo \"{{field}}\" no forma parte de esta especificación de regulador.",
      "querydef_readonly": "Este EDD es un Jet QueryDef y es de solo lectura aquí — clónelo para editarlo.",
      "single_file_parity": "Los EDD de archivo único requieren que las cuadrículas SX y QA tengan el mismo número de campos, orden y encabezados.",
      "bad_format": "Formato de salida no admitido.",
      "bad_separator": "Separador de delimitado no admitido.",
      "bad_xtable": "Tabla cruzada desconocida.",
      "crosstable_empty": "Las tablas cruzadas están activadas pero no se ha definido ninguna asignación de tabla cruzada.",
      "xmap_unknown_heading": "Una asignación de tabla cruzada hace referencia a un encabezado que no existe.",
      "crosstable_unmatched": "No se puede crear un EDD válido hasta que TODOS los elementos estén emparejados.",
      "crosstable_unmatched_table": "EDD cancelado por elementos sin emparejar en la tabla cruzada {{field}}.",
      "bad_source": "Fuente de generación no válida.",
      "bad_csv_zip": "El zip cargado no contiene archivos Out*.csv válidos.",
      "no_out_csvs": "No se encontraron archivos Out*.csv en la carga.",
      "output_mdb_unreadable": "No se pudo leer el output.mdb.",
      "schema": "La configuración no coincide con el esquema esperado.",
      "no_spec": "No se encontró ninguna especificación de regulador.",
      "drift_missing_field": "El campo obligatorio de la especificación \"{{field}}\" no es emitido por esta configuración.",
      "drift_extra_field": "El encabezado emitido \"{{field}}\" no está en la especificación actual.",
      "drift_renamed": "El encabezado \"{{field}}\" parece ser un campo de especificación renombrado.",
      "drift_type_mismatch": "El campo \"{{field}}\" tiene un tipo que no concuerda con la especificación.",
      "drift_out_of_sync": "Esta configuración se ha desviado de la especificación actual del regulador."
    }
  },
  "admin": {
    "adminsOnlyTitle": "Solo administradores",
    "adminsOnlyBody": "El panel de administración — gestión de usuarios, analíticas de uso, estado del sistema y cobertura de formatos — está restringido a administradores. Pida a un administrador que le otorgue el rol de administrador si necesita acceso.",
    "title": "Panel de administración",
    "subtitle": "Usuarios de la organización, analíticas de uso, estado del sistema y el resumen de cobertura de formatos.",
    "usersTitle": "Usuarios",
    "analyticsTitle": "Analíticas",
    "healthTitle": "Estado del sistema",
    "coverageTitle": "Cobertura de formatos",
    "roleChanged": "{{email}} ahora es {{role}}.",
    "userRemoved": "Usuario eliminado.",
    "colEmail": "Correo electrónico",
    "you": "usted",
    "youTitle": "Este es usted",
    "colRole": "Rol",
    "makeRole": "Hacer {{role}}",
    "cantChangeOwnRole": "No puede cambiar su propio rol.",
    "colConfigs": "Configuraciones",
    "colGenerations": "Generaciones",
    "delete": "Eliminar",
    "noUsersTitle": "No hay usuarios",
    "noUsersBody": "Su organización aún no tiene otros usuarios.",
    "deleteUserTitle": "Eliminar usuario",
    "cancel": "Cancelar",
    "deleteUserPrompt": "¿Eliminar a <0>{{email}}</0>? Sus configuraciones e historial permanecen en la organización, pero pierde el acceso inmediatamente.",
    "statUsers": "Usuarios",
    "statConfigs": "Configuraciones",
    "statMdbUploads": "cargas de .mdb",
    "statGenerations": "Generaciones",
    "statQuerydefTasks": "Tareas QueryDef",
    "successRate": "Tasa de éxito",
    "generationsByFormat": "Generaciones por formato",
    "topTemplates": "Plantillas principales",
    "noTemplateUsage": "Aún no hay uso de plantillas.",
    "generationsLast30": "Generaciones (últimos 30 días)",
    "aiUsage": "Uso de IA",
    "aiCalls": "{{n}} llamadas",
    "aiTokens": "{{n}} tokens",
    "noAiCalls": "No se registraron llamadas a la IA.",
    "noGenerationsYet": "Aún no hay generaciones.",
    "noGenerationsLast30": "No hay generaciones en los últimos 30 días.",
    "sparklineSummary": "{{total}} en total · pico {{peak}}/día",
    "healthDatabase": "Base de datos",
    "healthStorage": "Almacenamiento",
    "healthSidecar": "Sidecar",
    "healthAi": "IA ({{provider}})",
    "healthAiError": " · error",
    "healthWorkers": "Procesadores",
    "workersOnline": "{{n}} en línea",
    "version": "Versión {{version}}",
    "formatsCataloged": "formatos catalogados",
    "byTestStatus": "Por estado de prueba",
    "byRecoverability": "Por recuperabilidad",
    "byFamily": "Por familia",
    "unset": "(sin definir)"
  },
  "editor": {
    "subtitle": "Editor de formatos",
    "returnToWizardHint": "¿Terminó de crear este formato? Vuelva a su EDD y lo seleccionaremos por usted.",
    "returnToWizard": "Volver a generar mi EDD",
    "publish": {
      "draftHint": "Esto es un borrador — solo usted puede verlo. Vaya a la pestaña Vista previa, suba uno de sus archivos de datos y verifique que la salida se vea bien. Luego publíquelo para todo su laboratorio.",
      "button": "Publicar para mi laboratorio",
      "modalTitle": "¿Publicar este formato?",
      "modalBody": "Una vez que publique, todos en su laboratorio podrán usar este formato. Por favor confirme:",
      "confirm1": "Subí un archivo de datos y revisé la vista previa.",
      "confirm2": "Estoy seguro de que el resultado es correcto.",
      "published": "Publicado — su laboratorio ya puede usar este formato."
    },
    "chat": {
      "panelTitle": "Asistente",
      "empty": "Pregúntale al asistente lo que quieras sobre este formato — define columnas, escribe cálculos o traduce valores. Adjunta un archivo de referencia si tienes uno.",
      "collapse": "Ocultar",
      "reopen": "Asistente"
    },
    "guardrail": {
      "title": "¿Cambiar un requisito de su archivo?",
      "body": "Su archivo de requisitos pidió {{value}} en {{label}}. ¿Cambiarlo de todos modos?",
      "cancel": "Mantenerlo",
      "changeAnyway": "Cambiar de todos modos"
    },
    "unsaved": "sin guardar",
    "readOnlyBadge": "querydef · solo lectura",
    "version": "v{{version}}",
    "backToFormats": "← Formatos",
    "revert": "Revertir",
    "validate": "Revisar",
    "save": "Guardar",
    "whyReadOnly": "¿Por qué solo lectura?",
    "whyReadOnlyBody": "Este EDD se almacena como un Jet QueryDef nativo, que el motor en la nube no puede reescribir. Clónelo para hacer una copia editable aquí, o use el conector de Windows para reescribir el QueryDef en su máquina Promium.",
    "readOnlyBanner": "Este EDD se almacena como un Jet QueryDef y no se puede editar directamente. Clónelo para hacer una copia editable.",
    "cloneToEdit": "Clonar para editar",
    "cloneModalTitle": "Clonar para editar",
    "cloneNameLabel": "Nombre del nuevo formato",
    "createEditableCopy": "Crear copia editable",
    "editableSuffix": "(editable)",
    "editableCopyCreated": "Copia editable creada.",
    "fixBeforeSave": "Corrija los errores antes de guardar.",
    "savedWithErrors": "Guardado con errores — vea la franja a continuación.",
    "savedVersion": "Guardado como v{{version}}.",
    "backendPassed": "Revisión aprobada.",
    "backendIssues": "La revisión encontró problemas.",
    "techNoticeTitle": "Su equipo de control de calidad administra este formato",
    "techNoticeBody": "Los formatos los configura el administrador de su laboratorio / responsable de control de calidad. Puede ver este formato y usarlo en Crear un entregable.",
    "tabs": {
      "settings": "Ajustes",
      "mapping": "Columnas",
      "crosstable": "Traducciones de valores",
      "transforms": "Cálculos y reglas",
      "engine": "Lógica recuperada",
      "preview": "Vista previa",
      "tests": "Pruebas"
    },
    "tabHelp": {
      "crosstable": "Asigne los códigos de su laboratorio a los códigos del regulador (analito, matriz, unidades y más).",
      "transforms": "Reglas de autocompletado y calificadores que se ejecutan antes de crear el archivo.",
      "engine": "La lógica de transformación Jet-SQL de solo lectura recuperada del programa original de Promium de su laboratorio (eddcustom.dll) que convierte los datos de su laboratorio en este entregable. Solo se muestra cuando este formato realmente tiene lógica recuperada.",
      "tests": "Adjunte hasta cinco casos de prueba: un archivo de entrada de Promium más los archivos de salida correctos de su software anterior. Al ejecutar una prueba se genera este EDD y se compara cada archivo; si todas pasan, el formato se marca como plantilla válida."
    },
    "engine": {
      "provExtracted": "Recuperado de su eddcustom.dll",
      "provVerified": "Verificado — coincide exactamente con el original",
      "provBuiltin": "Motor de la biblioteca estándar incorporada",
      "none": "No hay lógica de motor adicional para este formato — es un escritor de columnas sencillo."
    },
    "settings": {
      "general": "General",
      "eddName": "Nombre del formato",
      "outputFormat": "Formato de salida",
      "separator": "Separador",
      "separatorHint": "Solo se aplica a la salida delimitada (CSV).",
      "fileExtension": "Extensión del archivo",
      "crossTableDb": "Base de datos de traducción de valores (.mdb)",
      "crossTableDbHint": "El libro usado para las traducciones de valores.",
      "quoteLevel": "Comillas de texto",
      "quoteLevelHelp": "Controla cuándo los valores de texto se rodean de comillas en la salida delimitada (CSV). Deje el valor Predeterminado a menos que la especificación del regulador requiera un estilo de comillas específico.",
      "quoteLevel0": "Predeterminado",
      "quoteLevel1": "Comillas en todos los valores",
      "quoteLevel2": "Comillas solo en valores de texto",
      "quoteLevel3": "Sin comillas",
      "queryDefName": "Nombre de la consulta guardada",
      "queryDefNameHelp": "Este formato ejecuta una consulta de Access guardada. Escriba el nombre de esa consulta guardada exactamente como está almacenado en la base de datos. Si se deja en blanco, se usa el nombre del formato.",
      "queryDefNameHint": "Deje en blanco para usar el nombre del formato.",
      "fileNames": "Nombres de archivo",
      "sxFileName": "Nombre del archivo/tabla de resultados de muestra",
      "qaFileName": "Nombre del archivo/tabla de resultados de QC",
      "flags": "Opciones",
      "includeHeaders": "Incluir fila de nombres de columna",
      "separateFiles": "Archivos separados de muestra / QC (dos archivos)",
      "useCrosstable": "Usar traducciones de valores",
      "addWo": "Usar la orden de trabajo en el nombre del archivo",
      "addDatestamp": "Agregar fecha/hora al nombre del archivo",
      "xTableExists": "El libro de traducción de valores existe",
      "xTableExistsHelp": "Indica que el libro de traducción de valores (.mdb) para este formato ya existe en el disco. Active esta opción si el libro ya se creó; déjela desactivada y el libro se creará la primera vez que se ejecute el formato.",
      "singleFileInfo": "Archivo único con QC: las columnas de resultados de muestra y de QC deben tener el mismo número, orden y nombres de columna. Rellene las columnas solo de muestra con valores estáticos ficticios."
    },
    "mapping": {
      "sxGrid": "Resultados de muestra",
      "qaGrid": "Resultados de QC",
      "headingRules": "Reglas de nombres de columna",
      "headingRulesBody": "Los nombres de columna pueden contener espacios y la mayoría de caracteres — se convierten en el encabezado CSV / campo de Access / etiqueta XML. La única salvedad: si un cálculo o regla referencia una columna, enciérrela entre corchetes (p. ej. [Result Value]).",
      "fieldTips": "Consejos de asignación de campos",
      "fieldTipsBody": "Algunos formatos esperan campos de origen específicos: la Fracción de Muestra (Sample Fraction) está en AnalysisInfo1, y el valor de PickList que necesita este formato se lee de AnalysisInfo4. Verifique el sys_loc_code del COC y edítelo si es necesario. Si a un registro le falta su valor de Total/Disuelto (T o D), salga e ingrese T o D manualmente, o elimine los registros con datos de TorD faltantes antes de generar.",
      "addStaticDummy": "+ Estático ficticio",
      "addField": "+ Agregar columna",
      "parityMismatch": "Archivo único con QC: los resultados de muestra tienen {{sx}} columnas, los de QC tienen {{qa}}. Deben coincidir en número, orden y nombres de columna.",
      "parityOk": "Archivo único con QC: las columnas de muestra y de QC deben compartir nombres idénticos en el mismo orden.",
      "emptyTitle": "No hay columnas en {{grid}}",
      "emptyReadOnly": "Esta cuadrícula está vacía.",
      "emptyEditable": "Agregue una columna, luego arrastre una fuente de la izquierda sobre ella para asignarla.",
      "addFirst": "+ Agregar la primera columna"
    },
    "fieldRow": {
      "dragToReorder": "Arrastre para reordenar",
      "headingPlaceholder": "Nombre de columna (sin espacios)",
      "mappedSource": "Fuente asignada",
      "staticPrefix": "= {{value}}",
      "dropSource": "suelte un campo de origen →",
      "hidden": "oculto",
      "removeField": "Quitar columna",
      "type": "Tipo",
      "size": "Tamaño",
      "dateFormat": "Formato de fecha",
      "dateFormatPlaceholder": "mm/dd/aaaa",
      "numberFormat": "Formato de número",
      "numberFormatPlaceholder": "0,000",
      "bitFormat": "Formato de bit (verdadero:falso)",
      "bitFormatPlaceholder": "S:N",
      "staticValue": "Valor estático",
      "staticValuePlaceholder": "literal o token",
      "splitDelimiter": "Delimitador de división",
      "splitDelimiterPlaceholder": "::",
      "item": "Elemento (base 1)",
      "hideFromOutput": "Ocultar de la salida"
    },
    "source": {
      "dragHint": "Arrastre sobre un nombre de columna para asignar {{table}}.{{field}}",
      "filterPlaceholder": "Filtrar campos de origen…",
      "noMatch": "Ningún campo de origen coincide."
    },
    "crosstable": {
      "intro": "Las traducciones de valores asignan los valores de Element a los códigos de valores válidos del cliente/regulador. <0>Los valores sin coincidencia salen en blanco — nunca dan error.</0>",
      "disabled": "Las traducciones de valores están desactivadas en Ajustes. Estas traducciones se guardan pero no se aplicarán hasta que active \"Usar traducciones de valores\".",
      "sxMaps": "Traducciones de muestra",
      "qaMaps": "Traducciones de QC",
      "addMapping": "+ Agregar traducción",
      "emptyTitle": "No hay traducciones de valores",
      "emptyBody": "Asigne una columna a una tabla de traducción para reemplazar sus valores con los códigos válidos del regulador.",
      "colTable": "Tabla de traducción",
      "colColumn": "Columna a traducir",
      "colSource": "Tabla de origen",
      "matchAllLabel": "Sobre el emparejamiento estricto",
      "matchAllHelp": "Algunos formatos requieren emparejamiento estricto: no se puede crear un EDD válido hasta que TODOS los elementos estén emparejados. Si algún elemento queda sin emparejar, la ejecución se cancela (por ejemplo: \"EDD cancelado por elementos sin emparejar en la tabla cruzada Analyte\"). Empareje cada valor antes de generar."
    },
    "crossTableValues": {
      "heading": "Tablas de traducción propias de esta plantilla",
      "intro": "Dé a esta plantilla sus propias tablas de valores válidos, cargadas como un libro X*.mdb o un solo X*.csv. Para cada tabla que cargue aquí, estos valores reemplazan los valores compartidos (de la organización) de su laboratorio SOLO para esta plantilla; las demás tablas siguen usando los valores compartidos.",
      "uploadLabel": "Cargar una tabla de traducción para esta plantilla",
      "uploadSublabel": "Libro X*.mdb o un solo X*.csv (p. ej. XAnalyte.csv)",
      "uploadHint": "El nombre del archivo (o de cada tabla dentro del .mdb) es la tabla cruzada que actualiza — p. ej. XAnalyte, XMatrix.",
      "uploading": "Cargando…",
      "uploaded": "Tabla de traducción guardada ({{rows}} filas).",
      "uploadError": "No se pudo cargar la tabla de traducción: {{detail}}",
      "colTable": "Tabla",
      "colRows": "Filas",
      "colSource": "Archivo de origen",
      "colUpdated": "Actualizado",
      "empty": "Aún no hay tablas de traducción por plantilla. Esta plantilla usa las tablas compartidas de su laboratorio hasta que cargue una aquí.",
      "confirmDeleteTitle": "Quitar anulación de tabla de traducción",
      "confirmDelete": "¿Quitar los valores \"{{name}}\" propios de esta plantilla? La generación volverá a los valores compartidos de su laboratorio para esa tabla.",
      "deleteSuccess": "Se quitó la anulación de \"{{name}}\".",
      "deleteError": "No se pudo quitar la tabla de traducción: {{detail}}",
      "saveAsBook": "Guardar como tabla cruzada reutilizable",
      "saveAsTitle": "Guardar como tabla cruzada reutilizable",
      "saveAsIntro": "Crea una tabla cruzada con nombre a partir de los valores de esta plantilla para reutilizarlos en otros formatos. La nueva tabla cruzada se adjunta a esta plantilla.",
      "saveAsNameLabel": "Nombre de la tabla cruzada",
      "saveAsConfirm": "Guardar como tabla cruzada",
      "savedAsBook": "Se guardó «{{name}}»: {{count}} valor(es). Ahora está adjunto y es reutilizable en cualquier formato.",
      "manageShort": "Tablas de traducción",
      "manageFor": "Tablas de traducción — {{name}}"
    },
    "transforms": {
      "functionHelp": "Funciones admitidas: IIF, SWITCH, MID, INSTR, VAL, Format y & para unir texto. Los cálculos y reglas se ejecutan contra las tablas de resultados de muestra / QC, referenciando columnas por su nombre de columna.",
      "sxTransforms": "Cálculos de muestra",
      "qaTransforms": "Cálculos de QC",
      "addTransform": "+ Agregar cálculo",
      "emptyTitle": "No hay cálculos ni reglas",
      "emptyBody": "Los cálculos y reglas son la única forma de calcular valores. Agregue uno para derivar columnas (p. ej., un calificador de no detectado a partir del resultado y el límite de detección).",
      "namePlaceholder": "Nombre del cálculo",
      "run": "Ejecutar",
      "dryRun": "Probar",
      "dryRunTitle": "Probar este cálculo contra filas de ejemplo",
      "dryRunDone": "Prueba completada.",
      "dryRunFailed": "El cálculo falló.",
      "before": "Antes",
      "after": "Después",
      "didNotRun": "El cálculo no se ejecutó.",
      "loadingEditor": "Cargando editor…",
      "sqlPlaceholder": "UPDATE SXDATA SET Qualifier = IIF(VAL(nResult) < VAL(nMDL), 'U', Qualifier)"
    },
    "preview": {
      "source": "Sus datos",
      "sampleData": "Datos de ejemplo (solo vista previa)",
      "sampleRows": "Filas de ejemplo",
      "runTransforms": "Ejecutar cálculos y reglas",
      "runPreview": "Ejecutar vista previa",
      "singleFile": "archivo único",
      "twoFiles": "dos archivos",
      "warnings_one": "{{count}} advertencia",
      "warnings_other": "{{count}} advertencias",
      "generatedOutput": "Salida generada",
      "resultsBelow": "Tablas de resultados a continuación.",
      "sxResult": "Resultados de muestra",
      "qaResult": "Resultados de QC",
      "rows_one": "{{count}} fila",
      "rows_other": "{{count}} filas",
      "summary": "Resumen del formato",
      "sumFormat": "Formato de salida",
      "sumExtension": "Extensión",
      "sumSx": "Columnas de muestra",
      "sumQa": "Columnas de QC",
      "sumTransforms": "Cálculos y reglas",
      "sumCrosstable": "Traducciones de valores",
      "on": "activado",
      "off": "desactivado"
    },
    "tests": {
      "intro": "Un caso de prueba combina un archivo de entrada de Promium con los archivos de salida correctos que produjo su software anterior. Ejecútelo para generar con este EDD y comparar cada archivo byte por byte.",
      "heading": "Casos de prueba",
      "count": "{{n}} de {{max}}",
      "validTemplate": "Plantilla válida",
      "validTemplateHint": "Todos los casos de prueba pasaron con la versión actual de este EDD.",
      "runAll": "Ejecutar todo",
      "run": "Ejecutar",
      "dirtyHint": "Tiene cambios sin guardar. Las pruebas siempre se ejecutan contra la versión GUARDADA: guarde primero para que los resultados reflejen lo que ve.",
      "addTest": "Agregar prueba",
      "capReached": "Este EDD tiene el máximo de {{max}} pruebas. Elimine una para agregar otra.",
      "nameLabel": "Nombre de la prueba",
      "namePlaceholder": "p. ej., Orden de trabajo 12345 — corrida completa",
      "inputKindLabel": "Tipo de entrada",
      "kindOutputMdb": "output.mdb de Promium",
      "kindCsvZip": "Zip de archivos Out*.csv",
      "inputFileLabel": "Archivo de entrada (de Promium)",
      "expectedFilesLabel": "Archivos de salida esperados (los archivos correctos)",
      "expectedFilesHint": "Los archivos del entregable que su software anterior generó para esta misma entrada. Los archivos de texto se comparan byte por byte; los .xlsx por contenido de celdas.",
      "create": "Crear prueba",
      "formIncomplete": "Asigne un nombre, un archivo de entrada y al menos un archivo de salida esperado.",
      "formIncompleteGenerate": "Asigne un nombre y un archivo de entrada para generar la salida.",
      "modeLabel": "Salida esperada",
      "modeUpload": "Subir archivos esperados (verificados)",
      "modeGenerate": "Generar y confirmar la salida esperada (para formatos nuevos)",
      "modeUploadHint": "Adjunte los archivos del entregable que su software anterior produjo para esta entrada.",
      "modeGenerateHint": "¿Aún no tiene un archivo verificado? Genere la salida con este EDD, previsualícela y guárdela como la referencia esperada con la que se compararán las ejecuciones futuras.",
      "generatePreview": "Generar vista previa",
      "generating": "Generando…",
      "previewTitle": "Vista previa de la salida generada",
      "previewBody": "Esta es la salida que este EDD produjo para su entrada. Confirme para guardar estos archivos exactos como la salida esperada de la prueba; las ejecuciones futuras se comparan con ellos byte por byte.",
      "confirmSave": "Confirmar y guardar",
      "bytes": "{{n}} bytes",
      "created": "Caso de prueba agregado.",
      "emptyTitle": "Aún no hay pruebas",
      "emptyBody": "Agregue su primer caso de prueba: suba un archivo de entrada de Promium y los archivos de salida correctos que debería producir.",
      "status": {
        "pending": "Sin ejecutar",
        "passed": "Aprobada",
        "failed": "Fallida",
        "error": "Error"
      },
      "stale": "Desactualizada",
      "staleHint": "Este EDD cambió desde la última ejecución de la prueba. Vuelva a ejecutarla para actualizar el resultado.",
      "expectedCount": "{{n}} archivo(s) esperado(s)",
      "hideDetail": "Ocultar detalles",
      "showDetail": "Ver detalles",
      "fileCol": "Archivo",
      "resultCol": "Resultado",
      "detailCol": "Detalle",
      "contentCompare": "contenido",
      "contentCompareHint": "Los libros de Excel se comparan por contenido de celdas (los bytes .xlsx siempre difieren).",
      "match": "Idéntico",
      "mismatch": "Diferente"
    }
  },
  "batch": {
    "title": "Varias órdenes de trabajo",
    "subtitle": "Ejecute un formato en muchas órdenes de trabajo. Obtenga un solo zip con una carpeta por orden de trabajo.",
    "history": "Historial",
    "format": "Formato",
    "selectFormat": "Seleccione un formato…",
    "output": "Salida",
    "checkEach": "Revisar cada orden de trabajo contra una norma de regulador",
    "autoDetect": "Detección automática",
    "sources": "Órdenes de trabajo ({{count}})",
    "addSource": "+ Agregar orden de trabajo",
    "uploadTitle": "Arrastre aquí una exportación de orden de trabajo para agregarla",
    "uploadSublabel": "o haga clic para buscar. La agregaremos como una fila nueva.",
    "uploadHint": ".mdb (output.mdb) o un zip con los archivos Out*.csv.",
    "uploading": "Cargando…",
    "sample": "Datos de ejemplo",
    "name": "Nombre del lote (opcional)",
    "namePlaceholder": "Por defecto, el nombre del formato",
    "run": "Ejecutar ({{count}})",
    "running": "Ejecutando {{count}} orden(es) de trabajo…",
    "openFullDetail": "Abrir detalle completo",
    "downloadAll": "Descargar todo (.zip)",
    "uploaded": "Cargado {{name}}.",
    "pickFormat": "Elija un formato para usar.",
    "addAtLeastOne": "Agregue al menos una orden de trabajo.",
    "pickOutput": "Elija al menos una salida.",
    "complete": "Todos los entregables listos.",
    "partial": "Terminado con algunos errores.",
    "failed": "La ejecución falló.",
    "colWorkOrder": "Orden de trabajo",
    "colStatus": "Estado",
    "colSx": "Filas de muestra",
    "colQa": "Filas de QC",
    "colFiles": "Archivos",
    "colCheck": "Revisión",
    "itemsOk": "{{done}}/{{total}} correctos",
    "itemsFailedSuffix": " · {{count}} con error"
  },
  "merge": {
    "title": "Combinar formatos",
    "subtitle": "Elija columnas de uno o más formatos en un nuevo formato. Los nombres de columna deben ser únicos; la paridad de archivo único se rellena automáticamente.",
    "newName": "Nombre del nuevo formato",
    "defaultName": "EDD combinado",
    "pickSource": "Elija una fuente",
    "myFormat": "Mi formato",
    "templateOption": "Formato estándar (por clase/nombre)",
    "sxGrid": "Resultados de muestra",
    "qaGrid": "Resultados de QC",
    "format": "Formato",
    "selectFormat": "Seleccione un formato…",
    "templateClass": "Clase o nombre del formato estándar",
    "templateClassPlaceholder": "p. ej. clsEQUIS o NYSDEC",
    "templateClassHint": "Use la clase/nombre exacto de la biblioteca de formatos.",
    "loadingFields": "Cargando columnas…",
    "colHeading": "Nombre de columna",
    "colSource": "Fuente",
    "add": "+ Agregar",
    "chooseFormatToList": "Elija un formato para listar sus columnas.",
    "enterTemplateToList": "Ingrese una clase/nombre de formato estándar para listar sus columnas.",
    "noFieldsInGrid": "No hay columnas en esta cuadrícula.",
    "selectedFields": "Columnas seleccionadas",
    "dupHeadings": "Nombres de columna duplicados (sin distinción de mayúsculas): {{names}}. Elimine o renombre antes de combinar.",
    "emptyCart": "Agregue columnas de la izquierda para construir su formato combinado.",
    "colGrid": "Cuadrícula",
    "colFrom": "De",
    "createMerged": "Crear formato combinado",
    "pickAtLeastOne": "Elija al menos una columna para combinar.",
    "resolveDup": "Resuelva los nombres de columna duplicados antes de combinar.",
    "created": "Formato combinado creado."
  },
  "specs": {
    "title": "Normas",
    "aboutLabel": "Acerca de las normas",
    "aboutBody": "Una norma es la forma objetivo que un regulador o cliente espera: las columnas obligatorias, sus tipos, las listas de valores válidos y los formatos de fecha/número. Revise o compruebe la desviación de su EDD antes de enviarlo. Las normas integradas (de archivo) son de solo lectura; los administradores pueden sembrarlas en la base de datos para hacer copias editables y versionadas.",
    "subtitle": "El registro combinado — normas integradas más las normas vivas de su organización (las de su organización ganan en conflictos).",
    "seed": "Sembrar normas integradas → base de datos",
    "newSpec": "+ Nueva norma",
    "seeded": "Se sembraron {{seeded}} norma(s) en la base de datos ({{skipped}} ya presentes).",
    "searchLabel": "Buscar",
    "searchPlaceholder": "nombre, regulador, familia…",
    "noSpecs": "No hay normas",
    "tryAnother": "Pruebe una búsqueda diferente.",
    "selectSpec": "Seleccione una norma",
    "selectSpecBody": "Elija una norma a la izquierda para ver sus columnas, el historial de versiones y ejecutar una comprobación de desviación.",
    "fieldsLabel": "campos",
    "org": "organización",
    "validValueLists": "listas de valores válidos",
    "readOnly": "solo lectura",
    "readOnlyTitle": "Las normas integradas / globales son de solo lectura. Siémbrelas en la base de datos para editarlas.",
    "regulator": "Regulador",
    "family": "Familia",
    "effective": "Vigente",
    "fieldCount": "Campos",
    "deleteTitle": "Eliminar norma",
    "deleted": "Norma eliminada.",
    "deletePrompt": "¿Eliminar <0>{{name}}</0> y su historial de versiones? Esta acción no se puede deshacer. Las normas integradas no se ven afectadas.",
    "fields": "Columnas",
    "noFieldsTitle": "No hay columnas registradas",
    "noFieldsBody": "Esta norma no tiene lista de columnas — solo se conocen sus metadatos.",
    "colField": "Columna",
    "colType": "Tipo",
    "colRequired": "Obligatorio",
    "colFormatSize": "Formato / tamaño",
    "colValidValues": "Valores válidos",
    "required": "obligatorio",
    "sizeLabel": "tamaño {{size}}",
    "versionHistory": "Historial de versiones",
    "noSnapshots": "Aún no hay instantáneas.",
    "colVersion": "Versión",
    "colLabel": "Etiqueta",
    "colFields2": "Campos",
    "colSummary": "Resumen",
    "colCreated": "Creado",
    "from": "Desde",
    "to": "Hasta",
    "pickTwo": "Elija dos versiones diferentes para comparar.",
    "noDiff": "No hay diferencias de columnas entre estas versiones.",
    "added": "+{{count}} agregadas",
    "removed": "−{{count}} eliminadas",
    "changed": "{{count}} modificadas",
    "addedSuffix": "agregada",
    "removedSuffix": "eliminada",
    "changedSuffix": "modificada",
    "checkDrift": "Comprobar desviación",
    "aboutDrift": "Acerca de la desviación",
    "aboutDriftBody": "La desviación compara los nombres de columna y tipos emitidos por un formato con las columnas actuales de esta norma. Marca columnas obligatorias faltantes, columnas adicionales, probables renombres y discrepancias de tipo — y sugiere una corrección.",
    "driftIntro": "Ejecute uno de sus formatos guardados contra <0>{{name}}</0> para ver si su salida aún coincide con la norma.",
    "selectFormat": "Seleccione un formato…",
    "loadingConfigs": "Cargando formatos…",
    "pickConfigFirst": "Elija un formato y deje que cargue primero.",
    "driftReport": "Informe de desviación",
    "inSync": "✓ Sincronizado",
    "outOfSync": "Desincronizado",
    "matchesSpec": "La salida del formato coincide con la norma.",
    "missingRequired": "Columna obligatoria faltante",
    "typeMismatch": "{{field}} es {{eddType}}, la norma espera {{specType}}",
    "renamedSuspect": "parece un renombre de",
    "matchScore": "({{score}}% de coincidencia)",
    "extraColumn": "Columna adicional",
    "notInSpec": "(no está en la norma)",
    "specKeyRequired": "La clave y el nombre de la norma son obligatorios.",
    "fieldNoSpaces": "Los nombres de columna no pueden contener espacios (se convierten en identificadores de columna/XML/SQL).",
    "updated": "Norma actualizada — nueva versión guardada.",
    "created": "Norma creada.",
    "editTitle": "Editar {{name}}",
    "newTitle": "Nueva norma de regulador",
    "saveNewVersion": "Guardar nueva versión",
    "createSpec": "Crear norma",
    "specKey": "Clave de la norma",
    "specKeyHint": "Id estable; elimina duplicados frente a las normas integradas. Por defecto, el nombre.",
    "name": "Nombre",
    "version": "Versión",
    "sourceUrl": "URL de origen",
    "notes": "Notas",
    "fieldRules": "Reglas de columnas",
    "fieldRulesBody": "Los nombres de columna se convierten en encabezados de columna / etiquetas XML / identificadores SQL, por lo que no deben contener espacios. Agregue valores válidos como una lista separada por comas para exigir la pertenencia durante una revisión.",
    "addField": "+ Agregar columna",
    "fieldName": "Nombre",
    "fieldType": "Tipo",
    "remove": "Eliminar",
    "validValues": "Valores válidos (separados por comas, opcional)",
    "changeSummary": "Resumen del cambio (para la instantánea de versión)",
    "changeSummaryPlaceholder": "p. ej. se agregó la lista de valores válidos de matriz",
    "confidenceBadge": "confianza {{level}}",
    "aboutConfidence": "Acerca de la confianza de extracción",
    "aboutConfidenceBody": "Cuánto confiar en los datos extraídos automáticamente de esta norma (límites de CC, listas de analitos, formatos). Alta significa una fuente limpia y estructurada; baja significa que la fuente fue más difícil de interpretar y conviene verificar los valores contra el documento original.",
    "extractedFrom": "Extraído de la fuente",
    "extractedAt": "extraído {{date}}",
    "colQc": "Límites de CC",
    "colAnalytes": "Analitos",
    "analyteVocab": "vocabulario",
    "analyteCasCount": "{{count}} números CAS",
    "more": "más"
  },
  "worker": {
    "title": "Conector de Windows",
    "subtitle": "Los EDD basados en QueryDef no pueden ser escritos por el motor en la nube. Ejecute el conector en su máquina Promium / Windows y este escribe QueryDefs Jet nativos localmente, luego devuelve el archivo aquí.",
    "registerWorker": "+ Registrar conector",
    "registeredWorkers": "Conectores registrados",
    "colName": "Nombre",
    "colStatus": "Estado",
    "colVersion": "Versión",
    "colCaps": "Capacidades",
    "colSeen": "Visto por última vez",
    "remove": "Eliminar",
    "removed": "Conector eliminado.",
    "noWorkersTitle": "No hay conectores registrados",
    "registerOne": "Registrar un conector",
    "askAdmin": "Pida a un administrador que registre un conector.",
    "noWorkersBody": "Descargue el conector, regístrelo aquí y aparecerá una vez que se conecte.",
    "removeTitle": "Eliminar conector",
    "removePrompt": "¿Eliminar <0>{{name}}</0>? Su token deja de funcionar inmediatamente y ya no puede reclamar tareas.",
    "never": "nunca",
    "registerTitle": "Registrar un conector de Windows",
    "workerName": "Nombre del conector",
    "defaultWorkerName": "Conector Promium",
    "done": "Listo",
    "register": "Registrar",
    "registered": "Conector registrado.",
    "copyTokenWarning": "Copie este token ahora — se muestra solo una vez. Guárdelo en la máquina del conector.",
    "copied": "¡Copiado!",
    "copy": "Copiar",
    "copyFailed": "No se pudo copiar — seleccione y copie el token manualmente.",
    "tokenInstructions": "En su máquina Windows, instale el conector desde <0>web/agent-worker</0> y ejecútelo con este token (enviado como el encabezado <1>X-Worker-Token</1>). Empezará a consultar tareas de reescritura de QueryDef.",
    "registerInstructions": "El registro genera un token por conector que se muestra una vez. El conector (en <0>web/agent-worker</0>) lo usa para autenticarse y consultar tareas. Solo los administradores pueden registrar o eliminar conectores.",
    "enqueueTitle": "Enviar una reescritura de QueryDef",
    "enqueueSubtitle": "Elija un EDDBuilderData.mdb cargado y los formatos basados en QueryDef a escribir. Un conector en línea reclama la tarea, escribe los QueryDefs Jet nativos y carga el resultado.",
    "mdbFile": "archivo .mdb",
    "selectMdb": "Seleccione un .mdb…",
    "loadingMdb": "Cargando sus archivos .mdb…",
    "mdbConfigs": "{{filename}} ({{count}} formatos)",
    "noQuerydefConfigs": "Este .mdb no tiene formatos basados en QueryDef (o sus resúmenes de formato no están cargados). Solo los formatos QueryDef necesitan el conector; los demás se reescriben desde el motor directamente.",
    "colConfig": "Formato",
    "colFormat": "Salida",
    "enqueue": "Enviar reescritura ({{count}})",
    "pickMdb": "Elija un archivo .mdb.",
    "selectQuerydef": "Seleccione al menos un formato QueryDef para reescribir.",
    "taskQueued": "Tarea en cola. Esperando a que un conector la reclame…",
    "writebackTask": "Tarea de reescritura",
    "worker": "conector {{id}}",
    "waitingClaim": "Esperando a que un conector en línea reclame esta tarea…",
    "writing": "Un conector está escribiendo los QueryDefs…",
    "downloadWritten": "Descargar .mdb escrito",
    "taskFailed": "El conector no pudo completar esta reescritura. Compruebe que esté en línea e inténtelo de nuevo."
  },
  "profile": {
    "title": "Perfil",
    "account": "Cuenta",
    "email": "Correo electrónico",
    "displayName": "Nombre para mostrar",
    "organization": "Organización: {{name}}",
    "saveProfile": "Guardar perfil",
    "notifyTitle": "Notificaciones",
    "notifyNewSignups": "Avísame sobre nuevos registros",
    "notifyNewSignupsHint": "Recibe un correo y una alerta en la app la primera vez que un nuevo usuario inicia sesión.",
    "saved": "Perfil actualizado.",
    "orgTitle": "Organización",
    "orgName": "Nombre",
    "orgId": "ID de organización",
    "mdbCount": "archivos .mdb",
    "mdbSectionTitle": "Bases de datos de formatos (.mdb)",
    "uploading": "Cargando e importando formatos…",
    "dropTitle": "Suelte aquí su EDDBuilderData.mdb",
    "dropBody": "o haga clic para buscar. Importamos sus formatos EDD a su espacio de trabajo.",
    "chooseMdb": "Elija un archivo .mdb (EDDBuilderData.mdb).",
    "uploaded": "Cargado {{name}}.",
    "noMdb": "Aún no se han cargado archivos .mdb.",
    "colFile": "Archivo",
    "colSize": "Tamaño",
    "colStatus": "Estado",
    "colConfigs": "Formatos",
    "download": "Descargar",
    "writeBack": "Reescribir…",
    "delete": "Eliminar",
    "deleteConfirm": "¿Eliminar {{name}}?",
    "writebackTitle": "Reescribir formatos en {{filename}}",
    "writebackIntro": "Seleccione qué formatos escribir en una copia nueva de este .mdb. Los formatos basados en QueryDef se omiten automáticamente (no pueden ser escritos por el motor).",
    "noSummaries": "No hay resúmenes de formato importados disponibles para este archivo. Vuelva a abrir el detalle del archivo para cargarlos, o reescriba desde el editor una vez importados los formatos.",
    "wbColConfig": "Formato",
    "wbColFormat": "Salida",
    "wbColQuerydef": "QueryDef",
    "wbReadOnly": "solo lectura",
    "writeBackAction": "Reescribir",
    "skipped": "Se omitieron {{count}} formato(s) QueryDef — son de solo lectura.",
    "wbComplete": "Reescritura completa. Su .mdb está listo para descargar.",
    "wbIssues": "La reescritura produjo problemas.",
    "promiumTitle": "Actualizar archivos de Promium",
    "promiumBody": "Agrega archivos que omitiste, o vuelve a importar después de una actualización de Element. Traeremos cualquier plantilla, motor y mapeo de tablas cruzadas nuevos.",
    "promiumStart": "Importar archivos de Promium",
    "crossTables": {
      "title": "Tablas cruzadas",
      "body": "Tablas de traducción de valores válidos cargadas desde tus archivos X*.mdb. Son utilizadas por formatos de tablas cruzadas como EQuIS.",
      "colName": "Tabla",
      "colRows": "Filas",
      "colSource": "Archivo fuente",
      "colImported": "Importado",
      "delete": "Eliminar",
      "confirmDelete": "¿Eliminar la tabla cruzada \"{{name}}\"? Esto elimina todas sus filas del almacén de su organización. Puede volver a cargar el libro de trabajo para restaurarla.",
      "confirmDeleteTitle": "Eliminar tabla cruzada",
      "cancel": "Cancelar",
      "confirm": "Confirmar eliminación",
      "reupload": "Volver a cargar libros de trabajo",
      "empty": "Aún no se han cargado tablas cruzadas. Cargue un libro de trabajo de tablas cruzadas (X*.mdb) usando la sección Actualizar archivos de Promium.",
      "deleteSuccess": "Tabla cruzada \"{{name}}\" eliminada.",
      "deleteError": "No se pudo eliminar la tabla cruzada: {{detail}}",
      "colElmntValue": "Valor de Element",
      "colMappedValue": "Valor asignado",
      "colMappedValue2": "Valor asignado 2",
      "valuesOf": "Valores — {{name}}",
      "valuesTotalHint": "Mostrando {{shown}} de {{total}} filas",
      "loadingValues": "Cargando valores…",
      "noValuesYet": "No se encontraron valores para esta tabla.",
      "prevPage": "← Anterior",
      "nextPage": "Siguiente →"
    }
  },
  "notifications": {
    "title": "Notificaciones",
    "unread": "{{count}} sin leer",
    "markAll": "Marcar todas como leídas",
    "empty": "Aún no hay notificaciones."
  },
  "sessions": {
    "title": "Dispositivos y sesiones",
    "subtitle": "Dónde tienes la sesión iniciada. Cierra un dispositivo si no lo reconoces.",
    "empty": "No hay sesiones activas.",
    "thisDevice": "Este dispositivo",
    "unknownDevice": "Dispositivo desconocido",
    "lastActive": "Última actividad {{when}}",
    "signOut": "Cerrar sesión",
    "signOutOthers": "Cerrar otros dispositivos",
    "signedOut": "Ese dispositivo cerró sesión.",
    "signedOutOthers": "Se cerró la sesión en tus otros dispositivos."
  },
  "templateDetail": {
    "backToLibrary": "← Todos los formatos",
    "spec": "Especificación ↗",
    "cloneToConfigs": "Agregar a mis formatos",
    "about": {
      "title": "Acerca de este EDD",
      "forStandard": "Este es un formato de la biblioteca de EDD estándar para {{subject}}.",
      "forSiteCustom": "Este es un EDD específico de sitio hecho exclusivamente para su laboratorio: {{subject}}.",
      "forCustom": "Este es uno de sus EDD personalizados: {{subject}}.",
      "subjectFallback": "un entregable electrónico de datos para resultados de laboratorio ambiental",
      "fields_one": "**{{count}} campo**",
      "fields_other": "**{{count}} campos**",
      "transforms_one": "**{{count}} transformación**",
      "transforms_other": "**{{count}} transformaciones**",
      "crossTables_one": "usa **{{count}} tabla de equivalencias**",
      "crossTables_other": "usa **{{count}} tablas de equivalencias**",
      "noCrossTables": "sin tablas de equivalencias",
      "statusReady": "✅ Listo para generar",
      "statusNeedsCrosstable": "⚠️ Necesita configurar la tabla de equivalencias",
      "statusPreviewOnly": "👁️ Solo vista previa — clónelo para editar"
    },
    "publicSpec": "especificación pública",
    "notes": "Notas",
    "provenance": "Procedencia",
    "kind": "Tipo",
    "recoverability": "Recuperabilidad",
    "hasConfig": "Tiene formato",
    "yes": "Sí",
    "specOnly": "Solo especificación",
    "sxFields": "Columnas de muestra",
    "qaFields": "Columnas de QC",
    "output": "Salida",
    "format": "Formato",
    "separator": "Separador",
    "extension": "Extensión",
    "crossTable": "Traducciones de valores",
    "twoFile": "Dos archivos",
    "no": "No",
    "singleFile": "Archivo único",
    "sxFieldsTitle": "Columnas de muestra",
    "qaFieldsTitle": "Columnas de QC",
    "specOnlyBanner": "Este formato está catalogado como solo especificación — su configuración aún no se ha portado. Aún puede agregarlo para empezar desde un formato editable en blanco.",
    "cloneModalTitle": "Agregar a mis formatos",
    "cloned": "Agregado a sus formatos.",
    "newConfigName": "Nombre del nuevo formato",
    "createsCopy": "Crea una copia editable en su espacio de trabajo desde <0>{{class}}</0>.",
    "clone": "Agregar",
    "colNum": "#",
    "colHeading": "Nombre de columna",
    "colSource": "Fuente",
    "colType": "Tipo",
    "colSize": "Tamaño",
    "colStatic": "Estático",
    "colHidden": "Oculto",
    "fieldsCount": "{{count}} columnas",
    "yesLower": "sí",
    "transformsTitle": "Transformaciones (muestra)",
    "qaTransformsTitle": "Transformaciones (QC)",
    "transformsCount": "{{count}} transformaciones",
    "transformsNote": "Jet SQL recuperado, se ejecuta en orden después de construir las columnas. `'` marca un valor calculado en tiempo de ejecución a partir de los datos del laboratorio.",
    "noTransforms": "No se recuperaron transformaciones para este formato.",
    "colTransformName": "Nombre",
    "colTransformSql": "Jet SQL (UPDATE)",
    "crossMapsTitle": "Mapas de valores de tabla cruzada (muestra)",
    "qaCrossMapsTitle": "Mapas de valores de tabla cruzada (QC)",
    "crossMapsCount": "{{count}} mapas",
    "colXtable": "Tabla de valores válidos",
    "colXsource": "Columna de origen",
    "provClass": "Clase VB6",
    "provDll": "DLL",
    "provBlock": "Bloque de origen",
    "provRecovered": "Campos recuperados",
    "sectionsTitle": "Secciones de salida (archivos)",
    "sectionsNote": "Este formato genera un archivo por sección, todos a partir de una sola tabla de trabajo.",
    "sectionsCount": "{{count}} archivos",
    "colSection": "Sección",
    "colSectionFiles": "Archivo(s) de salida",
    "colSectionColCount": "N.º de columnas",
    "colSectionColumns": "Columnas",
    "runtimeOptionsTitle": "Opciones al generar",
    "runtimeOptionsNote": "Se eligen en el cuadro de diálogo de la Biblioteca EDD al ejecutar el EDD (no quedan fijas en el formato). Se muestran los valores predeterminados.",
    "runtimeOptionsCount": "{{count}} opciones",
    "colOption": "Opción",
    "colDefault": "Predeterminado",
    "dialogControlsTitle": "Cuadro de diálogo de opciones",
    "colXpopulates": "Llena la columna",
    "engineTitle": "Lógica del motor (recuperada de eddlib.dll)",
    "engineNote": "Recuperada textualmente de la aplicación compilada. Compartida por todos los formatos construidos sobre el motor {{table}} — las transformaciones, tablas cruzadas y opciones reales que convierten los datos del laboratorio en este entregable.",
    "engineCrossLabel": "Traducciones de valores de tabla cruzada",
    "engineOptionsLabel": "Opciones del motor",
    "engineShow": "Mostrar las {{count}} transformaciones",
    "engineHide": "Ocultar transformaciones"
  },
  "setup": {
    "title": "Configure su laboratorio",
    "subtitle": "Traiga sus formatos de la aplicación EDD Builder anterior — sin volver a escribir nada.",
    "stepLabel1": "Encuentre su archivo",
    "stepLabel2": "Importar",
    "step1Title": "1. Encuentre su EDDBuilderData.mdb",
    "step1Body": "En su máquina Windows, esta es la base de datos de configuración que usa el EDD Builder anterior — generalmente en su directorio centralizado de tablas cruzadas. Contiene cada formato EDD que su laboratorio ha creado.",
    "step2Title": "2. Cárguelo aquí",
    "step2Body": "Suelte el archivo abajo. Leemos sus formatos e importamos cada uno como un formato EDD editable. No se envía nada a un regulador — esto solo trae su configuración.",
    "dropTitle": "Arrastre aquí su EDDBuilderData.mdb",
    "dropBrowse": "o haga clic para buscar",
    "dropHint": "Solo se aceptan archivos .mdb del EDD Builder anterior.",
    "uploading": "Cargando e importando sus formatos…",
    "chooseMdb": "Elija un archivo .mdb (EDDBuilderData.mdb).",
    "uploadFailed": "No pudimos importar ese archivo.",
    "successTitle": "Se importaron {{count}} formato(s)",
    "successZeroTitle": "Archivo cargado",
    "successBody": "Sus formatos están ahora en Formatos EDD, listos para editar o usar en un entregable.",
    "successZeroBody": "No encontramos formatos en ese archivo. Compruebe que sea el EDDBuilderData.mdb del EDD Builder anterior.",
    "goToFormats": "Ir a Formatos EDD",
    "goHome": "Ir al panel",
    "importAnother": "Importar otro archivo",
    "previouslyImported": "Ya ha importado {{count}} archivo(s). Cargue otro para agregar más formatos."
  },
  "promiumImport": {
    "orPickEach": "O sube cada archivo a mano",
    "orPickEachBody": "Si prefieres no comprimir toda la carpeta, busca cada archivo abajo y suéltalo aquí. Solo necesitas de verdad el primero.",
    "namePatternLabel": "Patrón del nombre:",
    "whatIsThisLabel": "¿Qué es esto?",
    "whereLabel": "¿Dónde encuentro esto?",
    "dropSingle": "Suelta el archivo aquí",
    "dropMulti": "Suelta tus archivos aquí",
    "dropBrowse": "o haz clic para buscar",
    "cardDropAria": "Subir {{name}}",
    "removeFile": "Quitar",
    "foundInZip": "✓ encontrado en tu zip",
    "notAZip": "Eso no parece un archivo .zip. Suelta una sola carpeta comprimida.",
    "fileTooLarge": "\"{{name}}\" es demasiado grande para subirlo aquí. Puede que sea el archivo equivocado.",
    "submit": "Configurar mi laboratorio",
    "gateHint": "Agrega tu EDDBuilderData.mdb para continuar (o sube un zip de tu carpeta C:\\Elmnt).",
    "uploadingAria": "Configurando tu laboratorio",
    "uploadingPct": "Subiendo… {{pct}}%",
    "missingRecommendedTitle": "Faltan algunos archivos útiles — no pasa nada",
    "addLater": "Puedes agregarlos más tarde desde tu perfil.",
    "badge": {
      "required": "🔵 OBLIGATORIO",
      "recommended": "🟡 RECOMENDADO",
      "optional": "⚪ OPCIONAL"
    },
    "status": {
      "waiting": "En espera",
      "uploading": "Subiendo",
      "done": "Listo",
      "error": "Error"
    },
    "zip": {
      "title": "La forma más fácil: sube toda tu carpeta Elmnt",
      "body": "¿No quieres buscar cada archivo? Solo comprime toda tu carpeta C:\\Elmnt y suéltala aquí. Encontraremos todo automáticamente.",
      "dropTitle": "Suelta aquí tu carpeta Elmnt comprimida",
      "dropAria": "Sube un zip de tu carpeta C:\\Elmnt",
      "staged": "Listo para subir: {{name}}",
      "help": "Haz clic derecho en la carpeta C:\\Elmnt → Enviar a → Carpeta comprimida (en zip) → Sube el zip aquí."
    },
    "collector": {
      "button": "Descargar script recolector",
      "caption": "O ejecuta nuestro recolector en tu máquina Windows — encuentra todos los archivos, los comprime y tú subes ese único zip."
    },
    "summary": {
      "title": "¡Tu laboratorio está listo! 🎉",
      "body": "Esto es todo lo que puedes usar para crear EDD. Tienes tus propios EDD personalizados más una gran biblioteca de formatos estándar, todo en un solo lugar.",
      "whatIsThis": "ℹ️ ¿Qué es esto?",
      "custom": {
        "title": "Tus EDD personalizados",
        "count_one": "Encontramos **{{count}} EDD personalizado**.",
        "count_other": "Encontramos **{{count}} EDD personalizados**.",
        "explain": "Estas son tus plantillas EDD personales. Tienen tus asignaciones de campos, tus transformaciones y la configuración de tus tablas de equivalencias. Están listas para usar de inmediato."
      },
      "standard": {
        "title": "Biblioteca de EDD estándar",
        "count_one": "**{{count}} formato estándar** viene integrado en Prisma EDD Builder y está listo para usar.",
        "count_other": "**{{count}} formatos estándar** vienen integrados en Prisma EDD Builder y están listos para usar.",
        "explain": "Estos son los formatos EDD estándar integrados en Element: EQuIS, SDWIS, formatos de agencias estatales, formatos militares y más. Vienen integrados en Prisma EDD Builder; confirmamos que tu EDD Builder coincide con esta biblioteca estándar, así que funcionan exactamente igual que en Element."
      },
      "siteCustom": {
        "title": "EDD específicos de sitio",
        "count_one": "Encontramos **{{count}} formato específico de sitio**.",
        "count_other": "Encontramos **{{count}} formatos específicos de sitio**.",
        "explain": "Estos son formatos especiales hechos específicamente para tu laboratorio o tu estado."
      },
      "mappings": {
        "title": "Tus equivalencias",
        "explain": "Estas traducen los nombres de tu laboratorio a los códigos que exigen los reguladores. Por ejemplo, tu 'Mercurio' se convierte en el número CAS '7439-97-6'."
      },
      "errors": {
        "title": "Tu historial de errores",
        "body": "Encontramos algunos formatos que te dieron problemas antes.",
        "explain": "Encontramos algunos formatos que te dieron problemas antes. Hemos preconfigurado soluciones para estos."
      },
      "validValuesIntro": "Importamos",
      "vv": {
        "analyte_mappings_one": "**{{count}} mapeo de analito**",
        "analyte_mappings_other": "**{{count}} mapeos de analitos**",
        "matrix_codes_one": "**{{count}} código de matriz**",
        "matrix_codes_other": "**{{count}} códigos de matriz**",
        "unit_codes_one": "**{{count}} código de unidad**",
        "unit_codes_other": "**{{count}} códigos de unidad**"
      },
      "version": "Versión de Element detectada: **{{version}}**",
      "missing": "Falta: {{name}} — puedes agregarlo más tarde desde tu perfil.",
      "verifyPassed": "Todas las comprobaciones pasaron",
      "verifyFailedTitle": "Algunas comprobaciones necesitan una segunda revisión",
      "seeAllEdds": "Ver todos mis EDD →",
      "continue": "Ir al panel"
    },
    "cards": {
      "configDb": {
        "fileName": "EDDBuilderData.mdb",
        "aka": "A veces se llama `EDD Builder Data.mdb` o `EDDBuilderData_backup.mdb`",
        "pattern": "Cualquier archivo .mdb que tenga \"EDDBuilder\" o \"EDD\" y \"Data\" en el nombre",
        "what": "Este archivo tiene todas tus plantillas EDD — los mapeos de campos, las transformaciones, todo lo que has configurado en el EDD Builder a lo largo de los años.",
        "step1": "Abre el Explorador de archivos en tu computadora",
        "step2": "Ve a `C:\\Elmnt\\` (aquí es donde vive Promium Element)",
        "step3": "Busca un archivo llamado `EDDBuilderData.mdb` — normalmente está justo en esa carpeta",
        "step4": "Si no está ahí, revisa `C:\\Elmnt\\CrossTables\\` o `C:\\Program Files\\Promium\\Element\\`",
        "step5": "¿Aún no lo encuentras? Abre Element → Database Admin → mira la ruta de la base de datos en la barra de estado"
      },
      "eddlib": {
        "fileName": "eddlib.dll",
        "aka": "La biblioteca EDD principal",
        "pattern": "`eddlib.dll` — siempre es exactamente este nombre",
        "what": "Este es el cerebro detrás de los 161 formatos EDD estándar — EQuIS, SDWIS, formatos estatales, formatos militares. Sin él, solo podemos importar tus plantillas personalizadas, no los formatos integrados.",
        "step1": "Abre el Explorador de archivos",
        "step2": "Ve a `C:\\Elmnt\\`",
        "step3": "Busca `eddlib.dll` — pesa unos 22 MB, mucho más grande que otros archivos DLL",
        "step4": "Si no lo ves, prueba en `C:\\Program Files\\Promium\\Element\\`"
      },
      "eddcustom": {
        "fileName": "eddcustom.dll",
        "aka": "DLL personalizado o específico del sitio",
        "pattern": "`eddcustom.dll` — siempre exactamente este nombre. No todos los laboratorios lo tienen.",
        "what": "Algunos laboratorios tienen formatos EDD especiales hechos solo para ellos (como los formatos MDH de Minnesota). Este archivo tiene esos motores personalizados. Si nunca has usado formatos personalizados, quizá no tengas este archivo — no pasa nada, sáltalo.",
        "step1": "La misma carpeta que eddlib.dll: `C:\\Elmnt\\`",
        "step2": "Busca `eddcustom.dll` — es más pequeño que eddlib.dll (normalmente 1-5 MB)",
        "step3": "¿No lo tienes? Está bien — simplemente sáltalo"
      },
      "crosstableDb": {
        "fileName": "XEDDBuilder.mdb",
        "aka": "Libro de tablas cruzadas, tablas X, mapeos de valores válidos",
        "pattern": "Cualquier archivo .mdb que empiece con `X` — como `XEDDBuilder.mdb`, `XEQuIS.mdb`, `XNYSDEC.mdb`",
        "what": "Este archivo traduce los nombres internos de tu laboratorio a los códigos que aceptan los reguladores. Por ejemplo, mapea tu nombre de analito \"Mercurio\" al número CAS \"7439-97-6\". Sin esto, tendrás que reconstruir estos mapeos desde cero.",
        "step1": "Ve a `C:\\Elmnt\\CrossTables\\`",
        "step2": "Busca `XEDDBuilder.mdb` — este es el principal",
        "step3": "Quizá también veas otros archivos X como `XEQuIS.mdb` o `XNYSDEC.mdb` — súbelos también (Tarjeta 7)"
      },
      "outputDb": {
        "fileName": "output.mdb",
        "aka": "Exportación de orden de trabajo, datos de salida EDD",
        "pattern": "`output.mdb` — siempre este nombre, pero es temporal (Element crea uno nuevo cada vez)",
        "what": "Una muestra de los datos reales de tu laboratorio de una orden de trabajo. Sube una para que podamos mostrarte una vista previa real de tus EDDs durante la configuración — verás tus datos reales con formato en tus plantillas reales.",
        "step1": "Abre Element → ve a cualquier orden de trabajo completada → Reports → ejecuta cualquier EDD",
        "step2": "El `output.mdb` aparece en tu carpeta de salida EDD (normalmente `C:\\Elmnt\\ServerFolders\\EDD\\`)",
        "step3": "Tómalo justo después de ejecutarlo — Element lo sobrescribe cada vez"
      },
      "exe": {
        "fileName": "EDDBuilder.exe",
        "aka": "El programa EDD Builder",
        "pattern": "`EDDBuilder.exe` — siempre exactamente este nombre",
        "what": "La aplicación EDD Builder en sí. La usamos para detectar qué versión de Element estás ejecutando, para asegurarnos de que todo sea 100% compatible.",
        "step1": "La misma carpeta: `C:\\Elmnt\\`",
        "step2": "Busca `EDDBuilder.exe`"
      },
      "extraCrosstables": {
        "fileName": "Varios archivos .mdb",
        "aka": "Tablas cruzadas por formato, mapeos de reguladores",
        "pattern": "Archivos .mdb que empiezan con `X` — como `XEQuIS.mdb`, `XNYSDEC.mdb`, `XCMDP.mdb`, `XSDWIS.mdb`, `XSEDD.mdb`",
        "what": "Algunos formatos tienen sus propios archivos de mapeo separados. Si tienes archivos .mdb adicionales en tu carpeta CrossTables, súbelos todos aquí.",
        "step1": "Ve a `C:\\Elmnt\\CrossTables\\`",
        "step2": "Sube todos los archivos .mdb que veas (excepto EDDBuilderData.mdb, que va en la Tarjeta 1)",
        "note": "Esta es una zona de carga de varios archivos — arrastra todos los que quieras"
      },
      "log": {
        "fileName": "EDDLIBERR.LOG",
        "aka": "Registro de errores EDD",
        "pattern": "`EDDLIBERR.LOG` o `EDDLIBERR_*.LOG` — siempre tiene \"EDDLIBERR\" en el nombre",
        "what": "El registro de errores de tu EDD Builder a lo largo de los años. Podemos leerlo para encontrar qué formatos te dieron problemas y preconfigurar soluciones para que funcionen bien desde el principio.",
        "step1": "Ve a `C:\\Elmnt\\`",
        "step2": "Busca `EDDLIBERR.LOG`",
        "step3": "Quizá no exista si nunca has tenido errores de EDD (¡qué suerte!)"
      }
    }
  },
  "codeBooks": {
    "title": "Tablas cruzadas",
    "intro": "Conjuntos reutilizables de asignaciones de valores con nombre, normalmente uno por cliente. Adjunta cualquier tabla cruzada a un formato o usa el predeterminado del laboratorio que todos los formatos usan por defecto.",
    "searchPlaceholder": "Buscar por nombre…",
    "createButton": "Nueva tabla cruzada",
    "createTitle": "Crear una tabla cruzada",
    "nameLabel": "Nombre",
    "namePlaceholder": "p. ej. códigos MDEQ 2026",
    "created": "Tabla cruzada creada y adjuntada a este formato.",
    "cloned": "Clonado a «{{name}}»",
    "renamed": "Renombrado",
    "deleted": "Se eliminó «{{name}}»",
    "suggested": "Códigos sugeridos para {{count}} valor(es)",
    "saved": "Se guardaron {{count}} asignación(es)",
    "empty": "Ninguna tabla cruzada coincide con tu búsqueda.",
    "adminsOnlyTitle": "Solo administradores",
    "adminsOnlyBody": "Las tablas cruzadas las gestionan los administradores. Pide acceso a un administrador.",
    "colName": "Nombre",
    "colValues": "Valores",
    "colTables": "Tablas",
    "colSource": "Origen",
    "colUpdated": "Actualizado",
    "defaultBadge": "Predeterminado",
    "cloneButton": "Clonar",
    "cloneTitle": "Clonar «{{name}}»",
    "cloneIntro": "Crea una copia que puedes editar sin cambiar el original.",
    "renameTitle": "Renombrar tabla cruzada",
    "deleteTitle": "Eliminar tabla cruzada",
    "deleteConfirm": "¿Eliminar «{{name}}»? Los formatos que la usan volverán al predeterminado del laboratorio. Esto no se puede deshacer.",
    "editorIntro": "Elige una tabla, completa los códigos y deja que la IA sugiera el resto. Nada se guarda hasta que hagas clic en Guardar.",
    "backToList": "← Todas las tablas cruzadas",
    "tools": {
      "title": "Crear y compartir",
      "intro": "Inicia esta tabla cruzada a partir de los códigos conocidos de una especificación reguladora, importa asignaciones desde un CSV, o comparte (y obtén) con la comunidad.",
      "specLabel": "Iniciar desde una especificación",
      "specPlaceholder": "Elige una especificación reguladora…",
      "jumpstart": "Iniciar",
      "jumpstarted": "Se sembraron {{count}} asignación(es) desde la especificación.",
      "importFile": "Importar desde CSV",
      "imported": "Se importaron {{count}} asignación(es) ({{skipped}} fila(s) omitida(s)).",
      "regulatorLabel": "Regulador de la comunidad",
      "share": "Compartir con la comunidad",
      "importCommunity": "Importar códigos de la comunidad",
      "shared": "Se compartieron {{count}} asignación(es) con la comunidad.",
      "communityImported": "Se importaron {{count}} asignación(es) de la comunidad."
    },
    "tableLabel": "Tabla",
    "newTableLabel": "Agregar una tabla",
    "addTable": "Agregar",
    "noTables": "Esta tabla cruzada aún no tiene tablas. Agrega una para empezar a asignar.",
    "needsCode": "{{count}} valor(es) aún necesitan un código.",
    "allMapped": "Todos los valores tienen un código.",
    "suggestButton": "Sugerir códigos",
    "addValue": "Agregar valor",
    "saveButton": "Guardar ({{count}})",
    "colElmnt": "Tu valor",
    "colCode": "Código",
    "colLabel": "Etiqueta / CAS",
    "aiSuggests": "IA: {{code}} ({{pct}}%)",
    "accept": "Aceptar",
    "truncatedHint": "Mostrando los primeros {{max}} valores de esta tabla.",
    "attachHeading": "Tablas cruzadas",
    "attachIntro": "Marca cada tabla cruzada que debe usar este formato. Se combinan de arriba hacia abajo: cuando dos asignan el mismo valor, gana la que esté más arriba en la lista. Las anulaciones por tabla de este formato tienen prioridad sobre todas ellas. No marques ninguna para usar el predeterminado del laboratorio (las asignaciones compartidas de tu laboratorio).",
    "attachLabel": "Tablas cruzadas para este formato",
    "createNewOption": "+ Crear nueva tabla cruzada",
    "createIntro": "Asigna un nombre a tu nueva tabla cruzada. Empieza vacía: agrega asignaciones de valores en la página de Tablas cruzadas (o subiéndolas abajo) y luego será reutilizable en cualquier formato.",
    "createNameLabel": "Nombre de la tabla cruzada",
    "createConfirm": "Crear",
    "attached": "Se actualizaron las tablas cruzadas de este formato.",
    "noneYet": "Aún no hay tablas cruzadas con nombre. Crea una o divide tu predeterminado del laboratorio en tablas cruzadas abajo.",
    "priorityRank": "#{{rank}}",
    "priorityHint": "La que esté más arriba gana cuando dos tablas cruzadas asignan el mismo valor. Las anulaciones por tabla de este formato siguen teniendo prioridad sobre todas ellas.",
    "usingLabDefault": "No hay tablas cruzadas seleccionadas: este formato usa el predeterminado del laboratorio (las asignaciones compartidas de tu laboratorio).",
    "moveUp": "Subir {{name}}",
    "moveDown": "Bajar {{name}}",
    "splitButton": "Dividir el predeterminado del laboratorio en tablas cruzadas",
    "split": "Se crearon {{count}} tabla(s) cruzada(s) a partir de tu predeterminado del laboratorio.",
    "acceptAll": "Aceptar todo ({{count}})",
    "aiSuggestsNoPct": "IA: {{code}}",
    "deleteValueTitle": "¿Eliminar esta asignación?",
    "deleteValueConfirm": "¿Eliminar la asignación de «{{value}}»? Se quita de la tabla cruzada guardada y no se puede deshacer.",
    "editDefaultNote": "Editar el predeterminado del laboratorio cambia las asignaciones compartidas que todos los formatos usan por defecto."
  },
  "sadmin": {
    "nav": {
      "allOrgs": "Todas las Organizaciones"
    },
    "orgs": {
      "pageTitle": "Todas las Organizaciones",
      "pageSubtitle": "Explora cada laboratorio, ve sus ubicaciones y únete a cualquiera para acceder.",
      "searchLabel": "Buscar organizaciones",
      "searchPlaceholder": "Buscar por nombre…",
      "locationCount_one": "{{count}} ubicación",
      "locationCount_other": "{{count}} ubicaciones",
      "noOrgs": "Sin organizaciones",
      "noOrgsBody": "Aún no se han creado organizaciones.",
      "noResults": "Ninguna organización coincide con «{{query}}»",
      "noResultsClear": "Limpiar búsqueda",
      "guardTitle": "Acceso de superadministrador requerido",
      "guardBody": "Solo los superadministradores de la plataforma pueden ver todas las organizaciones.",
      "defaultLocation": "predeterminada",
      "alreadyJoined": "Unido"
    },
    "join": {
      "cta": "Unirse al laboratorio",
      "title": "Unirse a {{orgName}}",
      "body": "Te estás uniendo a {{orgName}} como miembro. Podrás cambiar a este laboratorio y acceder a sus formatos, datos y generación.",
      "confirm": "Unirse",
      "success": "Te uniste a {{orgName}}.",
      "alreadyMember": "Ya eres miembro"
    },
    "switch": {
      "label": "Laboratorio activo",
      "loading": "Cargando…",
      "returnToHome": "Volver a mi laboratorio",
      "notMemberError": "Debes unirte a este laboratorio primero."
    },
    "actingIn": {
      "label": "Actuando en:",
      "exit": "Salir"
    }
  },
  "org": {
    "noMembershipsError": "No tienes membresías de laboratorio. Contacta a tu administrador.",
    "labUnavailable": "Tu laboratorio activo ya no está disponible. Se cambió a tu laboratorio principal.",
    "switcherItemLabel": "Cambiar a {{org}} ({{role}})"
  },
  "members": {
    "nav": {
      "label": "Miembros"
    },
    "pageTitle": "Miembros del Laboratorio",
    "pageSubtitle": "Administra quién pertenece a este laboratorio y su rol.",
    "memberCount_one": "{{count}} miembro en {{orgName}}",
    "memberCount_other": "{{count}} miembros en {{orgName}}",
    "you": "tú",
    "guardTitle": "Acceso de administrador requerido",
    "guardBody": "Solo los administradores del laboratorio pueden gestionar miembros. Pide acceso a un administrador.",
    "empty": "Sin miembros",
    "emptyBody": "Agrega un miembro para darle acceso a este laboratorio.",
    "addMember": "Agregar Miembro",
    "cannotRemoveSelf": "No puedes eliminarte del laboratorio.",
    "lastAdminError": "No se puede eliminar o degradar al único administrador. Agrega otro administrador primero.",
    "loadError": "No se pudieron cargar los miembros. Verifica tu conexión e inténtalo de nuevo.",
    "add": {
      "title": "Agregar Miembro",
      "emailLabel": "Correo electrónico",
      "emailHint": "Debe ser una cuenta existente de Prisma EDD Builder.",
      "roleLabel": "Rol",
      "confirm": "Agregar Miembro",
      "success": "{{email}} agregado a este laboratorio.",
      "alreadyMember": "{{email}} ya es miembro de este laboratorio.",
      "notFound": "No se encontró ninguna cuenta para {{email}}. Pide a un superadministrador que la cree primero."
    },
    "remove": {
      "title": "Eliminar Miembro",
      "body": "¿Eliminar a {{email}} de {{orgName}}? Perderá todo acceso a los formatos y datos de este laboratorio.",
      "confirm": "Eliminar Miembro",
      "success": "{{email}} eliminado de este laboratorio."
    },
    "roleChange": {
      "label": "Rol de {{email}}",
      "save": "Guardar rol de {{email}}",
      "success": "{{email}} ahora es {{role}} en este laboratorio."
    },
    "roles": {
      "admin": "administrador",
      "tech": "técnico"
    }
  }
}
